// GENERATED FILE — do not edit by hand.
// Source: packages/contracts/fixtures/outbound-questionnaires/
//   vip-one-mnet-v2-template.json + vip-one-mnet-v2-bindings.json
// Regenerate with: node tools/generate-questionnaire-fixture-module.mjs
// The fixtures are embedded as raw JSON text (no JSON module imports) so the
// module loads identically under Node type stripping, Metro, esbuild and tsc.

const templateJsonText = String.raw`{
  "schemaVersion": "outbound-questionnaire-template-fixture-v1",
  "templateKey": "vip_one_mnet_preop",
  "displayName": "VIP One MNET preoperative intake",
  "clinicalPurpose": "Collect preoperative readiness history for VIP One MNET patients before surgery.",
  "locale": "en-US",
  "source": {
    "preparedFrom": "docs/engineering/vip-one-mnet-outbound-questionnaire-prep.md",
    "sourcePdfReference": "operator-held source PDF; not committed to repository",
    "phiStatus": "No patient data. Clinical content only.",
    "liveExportStatus": "pending_read_only_live_export_comparison",
    "liveExportRequiredBeforeMutation": true,
    "liveExportSafetyNote": "Before mutating VIP production data, perform a read-only export and compare counts/checksums against integrity.canonicalQuestionTextSha256. Do not export patient rows or answers into source control.",
    "liveCampaignIdentifiers": {
      "production": "not_committed_here; record non-secret template/campaign ids in the deployment runbook after read-only export",
      "testing": "not_committed_here; record non-secret template/campaign ids in the deployment runbook after read-only export"
    },
    "note": "Draft v2 generated from the content workbook — PROVISIONAL rows require the Shannon/Christina config session before publish."
  },
  "version": {
    "versionLabel": "v2-draft",
    "estimatedMinutes": 18,
    "resumePolicy": {
      "mode": "continue_from_last_unanswered_question",
      "allowPatientRequestedTime": true,
      "defaultResumeDelayMinutes": 240,
      "onDisconnectPauseDelayMinutes": 240,
      "onNoInputPauseDelayMinutes": 240,
      "maxPausedHours": 72,
      "maxResumeAttempts": 3,
      "checkpoints": [
        "consent_and_surgery_context",
        "ride_home_and_caregiver",
        "medications_and_allergies",
        "surgery_and_anesthesia_history",
        "social_and_basic_history",
        "cardiovascular_and_pulmonary",
        "other_systems",
        "final_attestation"
      ]
    },
    "reviewPolicy": {
      "policyKey": "vip_one_mnet_preop_review_v1",
      "unsureRequiresReviewDefault": true,
      "yellowFlagRouting": "clinician_review_required",
      "redFlagRouting": "clinician_review_required",
      "redFlagStopAutomationDefault": false,
      "clinicianReviewDisclosureRequired": true,
      "voicePolicy": {
        "tonePreset": "warm_clinical",
        "customToneInstructions": "",
        "introMode": "provider_first_powered_by_amplecare",
        "fullIntroText": "Hello, this is the automated care assistant calling on behalf of VIP Surgicare to complete your pre-surgery health questionnaire so we can get you ready for surgery. Completing this questionnaire is a required part of preparing for your procedure. You can end this call at any time — day or night — and when we call back you will pick up right where you left off.",
        "briefIntroText": "Hello, this is the automated care assistant calling on behalf of VIP Surgicare to continue your pre-surgery health questionnaire — we will pick up right where you left off.",
        "answerInstructionText": "Answer in your own words — you can say things like yes, no, or describe what happened. You can also ask me to repeat or go back to a previous question at any time.",
        "privacyDisclosureText": "For privacy, I will first confirm I am speaking with the right person before discussing questionnaire details.",
        "clinicianReviewDisclosureText": "Your answers are shared with your care team. Clinicians are monitoring and evaluating your responses, and a nurse will follow up before your surgery if anything needs attention.",
        "disclosureVersion": "vip-one-mnet-voice-policy-2026-06-23",
        "closingText": "Thank you — that completes your questionnaire. We look forward to caring for you at VIP. Please wear clothes that are easy to get on and off, and leave valuables at home. If you have any questions before your procedure, your care team is happy to help.",
        "scriptProvenance": "PROVISIONAL — replace with Shannon's human-touch doc in the config session"
      }
    },
    "questions": [
      {
        "questionKey": "consent_to_continue",
        "sectionKey": "call_start_and_consent",
        "sectionLabel": "Call Start and Consent",
        "sequenceNumber": 1,
        "promptText": "This is the automated care assistant for VIP, about your pre-surgery health questionnaire. Is now a good time to continue?",
        "answerType": "confirmation",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "A. Call Start and Consent",
          "sourceReviewNote": "No/pause should pause and reschedule."
        }
      },
      {
        "questionKey": "completing_for_self",
        "sectionKey": "call_start_and_consent",
        "sectionLabel": "Call Start and Consent",
        "sequenceNumber": 2,
        "promptText": "Are you the patient, answering these questions for yourself?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "A. Call Start and Consent",
          "sourceReviewNote": "If no, ask representative details."
        }
      },
      {
        "questionKey": "representative_name_relationship",
        "sectionKey": "call_start_and_consent",
        "sectionLabel": "Call Start and Consent",
        "sequenceNumber": 3,
        "promptText": "Please tell me your name and relationship to the patient.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "completing_for_self",
            "equals": false
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please tell me your name and relationship to the patient",
        "questionMetadata": {
          "sourceSection": "A. Call Start and Consent",
          "sourceReviewNote": "only_if previous no; review."
        }
      },
      {
        "questionKey": "confirm_planned_procedure",
        "sectionKey": "surgery_context_confirmation",
        "sectionLabel": "Surgery Context Confirmation",
        "sequenceNumber": 4,
        "promptText": "I have your planned procedure as {plannedProcedure}. Is that correct?",
        "answerType": "confirmation",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "noRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "I have your planned procedure as {plannedProcedure}. Is that correct",
        "questionMetadata": {
          "sourceSection": "B. Surgery Context Confirmation",
          "sourceReviewNote": "noRequiresReview."
        }
      },
      {
        "questionKey": "confirm_scheduled_date",
        "sectionKey": "surgery_context_confirmation",
        "sectionLabel": "Surgery Context Confirmation",
        "sequenceNumber": 5,
        "promptText": "I have your procedure scheduled for {scheduledProcedureDate}. Is that correct?",
        "answerType": "confirmation",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "noRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "I have your procedure scheduled for {scheduledProcedureDate}. Is that correct",
        "questionMetadata": {
          "sourceSection": "B. Surgery Context Confirmation",
          "sourceReviewNote": "noRequiresReview."
        }
      },
      {
        "questionKey": "confirm_surgeon",
        "sectionKey": "surgery_context_confirmation",
        "sectionLabel": "Surgery Context Confirmation",
        "sequenceNumber": 6,
        "promptText": "I have your surgeon as {surgeonName}. Is that correct?",
        "answerType": "confirmation",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "noRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "I have your surgeon as {surgeonName}. Is that correct",
        "questionMetadata": {
          "sourceSection": "B. Surgery Context Confirmation",
          "sourceReviewNote": "noRequiresReview.",
          "optionsRef": "@dynamic:facility_surgeons"
        }
      },
      {
        "questionKey": "has_ride_home",
        "sectionKey": "ride_home_and_post_surgery_care",
        "sectionLabel": "Ride Home and Post-Surgery Care",
        "sequenceNumber": 7,
        "promptText": "Do you have someone who will take you home after surgery?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "noRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "someone who will take you home after surgery",
        "questionMetadata": {
          "sourceSection": "C. Ride Home and Post-Surgery Care",
          "sourceReviewNote": "noRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "ride_home_name_relationship_phone",
        "sectionKey": "ride_home_and_post_surgery_care",
        "sectionLabel": "Ride Home and Post-Surgery Care",
        "sequenceNumber": 8,
        "promptText": "Please tell me the name, relationship, and phone number of the person taking you home.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "has_ride_home",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please tell me the name, relationship, and phone number of the person taking you",
        "questionMetadata": {
          "sourceSection": "C. Ride Home and Post-Surgery Care",
          "sourceReviewNote": "only_if has_ride_home yes; review."
        }
      },
      {
        "questionKey": "has_after_surgery_caregiver",
        "sectionKey": "ride_home_and_post_surgery_care",
        "sectionLabel": "Ride Home and Post-Surgery Care",
        "sequenceNumber": 9,
        "promptText": "Will someone care for you after surgery?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "noRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Will someone care for you after surgery",
        "questionMetadata": {
          "sourceSection": "C. Ride Home and Post-Surgery Care",
          "sourceReviewNote": "noRequiresReview."
        }
      },
      {
        "questionKey": "after_surgery_caregiver_details",
        "sectionKey": "ride_home_and_post_surgery_care",
        "sectionLabel": "Ride Home and Post-Surgery Care",
        "sequenceNumber": 10,
        "promptText": "Please tell me the name and phone number of the person who will care for you after surgery.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "has_after_surgery_caregiver",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please tell me the name and phone number of the person who will care for you aft",
        "questionMetadata": {
          "sourceSection": "C. Ride Home and Post-Surgery Care",
          "sourceReviewNote": "only_if has_after_surgery_caregiver yes; review."
        }
      },
      {
        "questionKey": "prior_surgeries",
        "sectionKey": "surgery_and_anesthesia_history",
        "sectionLabel": "Surgery and Anesthesia History",
        "sequenceNumber": 11,
        "promptText": "Have you had any prior surgeries?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any prior surgeries",
        "questionMetadata": {
          "sourceSection": "F. Surgery and Anesthesia History",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "prior_surgeries_detail",
        "sectionKey": "surgery_and_anesthesia_history",
        "sectionLabel": "Surgery and Anesthesia History",
        "sequenceNumber": 12,
        "promptText": "Please tell me each surgery, the approximate date, and whether there were any problems.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "prior_surgeries",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please tell me each surgery, the approximate date, and whether there were any pr",
        "questionMetadata": {
          "sourceSection": "F. Surgery and Anesthesia History",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview."
        }
      },
      {
        "questionKey": "anesthesia_problems_umbrella",
        "sectionKey": "surgery_and_anesthesia_history",
        "sectionLabel": "Surgery and Anesthesia History",
        "sequenceNumber": 13,
        "promptText": "Have you or anyone in your family ever had trouble with anesthesia — for example malignant hyperthermia, a pseudocholinesterase deficiency, severe nausea and vomiting afterwards, or any other problem?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "yesRequiresReview": true,
          "reviewSignal": "red_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "umbrellaSection": "surgery_and_anesthesia_history",
          "provenance": "shannon-2026-09-01-content-session"
        }
      },
      {
        "questionKey": "malignant_hyperthermia_history",
        "sectionKey": "surgery_and_anesthesia_history",
        "sectionLabel": "Surgery and Anesthesia History",
        "sequenceNumber": 14,
        "promptText": "Have you or a family member had malignant hyperthermia?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "anesthesia_problems_umbrella",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Have you or a family member had malignant hyperthermia",
        "questionMetadata": {
          "sourceSection": "F. Surgery and Anesthesia History",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "plainLanguageDefinition": "Malignant hyperthermia is a rare, serious reaction to some anesthesia medicines that can cause a very high fever and muscle rigidity.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "pseudocholinesterase_deficiency",
        "sectionKey": "surgery_and_anesthesia_history",
        "sectionLabel": "Surgery and Anesthesia History",
        "sequenceNumber": 15,
        "promptText": "Have you been told you have pseudocholinesterase deficiency?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "anesthesia_problems_umbrella",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Have you been told you have pseudocholinesterase deficiency",
        "questionMetadata": {
          "sourceSection": "F. Surgery and Anesthesia History",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "plainLanguageDefinition": "Pseudocholinesterase deficiency means the body may break down certain anesthesia medicines more slowly than usual.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "ponv_history",
        "sectionKey": "surgery_and_anesthesia_history",
        "sectionLabel": "Surgery and Anesthesia History",
        "sequenceNumber": 16,
        "promptText": "Have you had postoperative nausea and vomiting after anesthesia?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "anesthesia_problems_umbrella",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "postoperative nausea and vomiting after anesthesia",
        "questionMetadata": {
          "sourceSection": "F. Surgery and Anesthesia History",
          "sourceReviewNote": "yesRequiresReview.",
          "plainLanguageDefinition": "Postoperative nausea and vomiting means feeling sick or throwing up after anesthesia or surgery.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "motion_sickness",
        "sectionKey": "surgery_and_anesthesia_history",
        "sectionLabel": "Surgery and Anesthesia History",
        "sequenceNumber": 17,
        "promptText": "Do you get motion sickness?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "anesthesia_problems_umbrella",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Do you get motion sickness",
        "questionMetadata": {
          "sourceSection": "F. Surgery and Anesthesia History",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "other_anesthesia_problem",
        "sectionKey": "surgery_and_anesthesia_history",
        "sectionLabel": "Surgery and Anesthesia History",
        "sequenceNumber": 18,
        "promptText": "Have you had any other problem with anesthesia?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "anesthesia_problems_umbrella",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other problem with anesthesia",
        "questionMetadata": {
          "sourceSection": "F. Surgery and Anesthesia History",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "other_anesthesia_problem_detail",
        "sectionKey": "surgery_and_anesthesia_history",
        "sectionLabel": "Surgery and Anesthesia History",
        "sequenceNumber": 19,
        "promptText": "Please describe the anesthesia problem.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "other_anesthesia_problem",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe the anesthesia problem",
        "questionMetadata": {
          "sourceSection": "F. Surgery and Anesthesia History",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview."
        }
      },
      {
        "questionKey": "malignant_hyperthermia_who",
        "sectionKey": "surgery_and_anesthesia_history",
        "sectionLabel": "Surgery and Anesthesia History",
        "sequenceNumber": 20,
        "promptText": "Who had malignant hyperthermia?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "malignant_hyperthermia_history",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Who had malignant hyperthermia",
        "questionMetadata": {
          "sourceSection": "F. Surgery and Anesthesia History",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview.",
          "plainLanguageDefinition": "This follow-up asks whether the reaction happened to you or to a family member, because either can matter for anesthesia planning.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "takes_current_medications",
        "sectionKey": "medications",
        "sectionLabel": "Medications",
        "sequenceNumber": 21,
        "promptText": "Are you currently taking any prescription medicines, over-the-counter medicines, vitamins, or supplements?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Are you currently taking any prescription medicines, over-the-counter medicines,",
        "questionMetadata": {
          "sourceSection": "D. Medications",
          "sourceReviewNote": "yesRequiresReview.",
          "medicationReconciliation": {
            "capturesPatientReportedMedication": false,
            "requiresClinicianReview": true,
            "matchingEnabled": false,
            "matchingStatus": "external_medication_matching_not_configured"
          }
        }
      },
      {
        "questionKey": "current_medications_detail",
        "sectionKey": "medications",
        "sectionLabel": "Medications",
        "sequenceNumber": 22,
        "promptText": "Please list each medicine or supplement you take, including dose, how often you take it, and the reason if you know it.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "takes_current_medications",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please list each medicine or supplement you take, including dose, how often you ",
        "questionMetadata": {
          "sourceSection": "D. Medications",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview.",
          "medicationReconciliation": {
            "capturesPatientReportedMedication": true,
            "requiresClinicianReview": true,
            "matchingEnabled": false,
            "matchingStatus": "external_medication_matching_not_configured"
          },
          "optionsRef": "@dynamic:medication_doses"
        }
      },
      {
        "questionKey": "recent_blood_thinners",
        "sectionKey": "medications",
        "sectionLabel": "Medications",
        "sequenceNumber": 23,
        "promptText": "Have you recently used any blood thinners?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Have you recently used any blood thinners",
        "questionMetadata": {
          "sourceSection": "D. Medications",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "medicationReconciliation": {
            "capturesPatientReportedMedication": false,
            "requiresClinicianReview": true,
            "matchingEnabled": false,
            "matchingStatus": "external_medication_matching_not_configured"
          }
        }
      },
      {
        "questionKey": "recent_blood_thinners_detail",
        "sectionKey": "medications",
        "sectionLabel": "Medications",
        "sequenceNumber": 24,
        "promptText": "When did you last take it?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "recent_blood_thinners",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Which blood thinner did you use, and when did you last take it",
        "questionMetadata": {
          "sourceSection": "D. Medications",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview.",
          "medicationReconciliation": {
            "capturesPatientReportedMedication": false,
            "requiresClinicianReview": true,
            "matchingEnabled": false,
            "matchingStatus": "external_medication_matching_not_configured"
          }
        }
      },
      {
        "questionKey": "medication_allergies",
        "sectionKey": "allergies",
        "sectionLabel": "Allergies",
        "sequenceNumber": 25,
        "promptText": "Do you have any medication allergies?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any medication allergies",
        "questionMetadata": {
          "sourceSection": "E. Allergies",
          "sourceReviewNote": "yesRequiresReview.",
          "optionsRef": "@dynamic:medication_database"
        }
      },
      {
        "questionKey": "medication_allergy_reactions",
        "sectionKey": "allergies",
        "sectionLabel": "Allergies",
        "sequenceNumber": 26,
        "promptText": "Please tell me each medication you are allergic to and the reaction you get from it — for example 'penicillin, hives'.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "medication_allergies",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "alwaysRequiresReview": true,
          "trigger": "reaction=anaphylaxis",
          "consequence": "review-flag (red)"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What medication allergies do you have, and what reaction do you have to each",
        "questionMetadata": {
          "sourceSection": "E. Allergies",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview.",
          "answerTypeOverride": {
            "from": "multi_choice",
            "to": "short_text",
            "provenance": "shannon-2026-09-02-call"
          }
        }
      },
      {
        "questionKey": "other_allergies",
        "sectionKey": "allergies",
        "sectionLabel": "Allergies",
        "sequenceNumber": 27,
        "promptText": "Do you have any other allergies?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other allergies",
        "questionMetadata": {
          "sourceSection": "E. Allergies",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "other_allergy_reactions",
        "sectionKey": "allergies",
        "sectionLabel": "Allergies",
        "sequenceNumber": 28,
        "promptText": "Please tell me each of those other allergies and the reaction you get — for example 'bee stings, swelling'.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "other_allergies",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "alwaysRequiresReview": true,
          "trigger": "reaction=anaphylaxis",
          "consequence": "review-flag (red)"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What other allergies do you have, and what reaction do you have to each",
        "questionMetadata": {
          "sourceSection": "E. Allergies",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview.",
          "answerTypeOverride": {
            "from": "multi_choice",
            "to": "short_text",
            "provenance": "shannon-2026-09-02-call"
          }
        }
      },
      {
        "questionKey": "latex_products_allergy",
        "sectionKey": "allergies",
        "sectionLabel": "Allergies",
        "sequenceNumber": 29,
        "promptText": "Are you allergic or sensitive to latex products?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Are you allergic or sensitive to latex products",
        "questionMetadata": {
          "sourceSection": "E. Allergies",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "adhesive_tape_allergy",
        "sectionKey": "allergies",
        "sectionLabel": "Allergies",
        "sequenceNumber": 30,
        "promptText": "Are you allergic or sensitive to adhesive tape?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "latex_products_allergy",
            "equals": false
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Are you allergic or sensitive to adhesive tape",
        "questionMetadata": {
          "sourceSection": "E. Allergies",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "iv_contrast_xray_dye_allergy",
        "sectionKey": "allergies",
        "sectionLabel": "Allergies",
        "sequenceNumber": 31,
        "promptText": "Are you allergic or sensitive to IV contrast or X-ray dye?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Are you allergic or sensitive to IV contrast or X-ray dye",
        "questionMetadata": {
          "sourceSection": "E. Allergies",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "environmental_allergies",
        "sectionKey": "allergies",
        "sectionLabel": "Allergies",
        "sequenceNumber": 32,
        "promptText": "Do you have environmental allergies?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "environmental allergies",
        "questionMetadata": {
          "sourceSection": "E. Allergies",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "environmental_allergy_detail",
        "sectionKey": "allergies",
        "sectionLabel": "Allergies",
        "sequenceNumber": 33,
        "promptText": "Please describe your environmental allergies.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "environmental_allergies",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe your environmental allergies",
        "questionMetadata": {
          "sourceSection": "E. Allergies",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "food_allergies",
        "sectionKey": "allergies",
        "sectionLabel": "Allergies",
        "sequenceNumber": 34,
        "promptText": "Do you have food allergies?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "food allergies",
        "questionMetadata": {
          "sourceSection": "E. Allergies",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "food_allergy_detail",
        "sectionKey": "allergies",
        "sectionLabel": "Allergies",
        "sequenceNumber": 35,
        "promptText": "Please tell me each food allergy and the reaction you get from it.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "food_allergies",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe your food allergies and reactions",
        "questionMetadata": {
          "sourceSection": "E. Allergies",
          "sourceReviewNote": "only_if yes; review.",
          "answerTypeOverride": {
            "from": "multi_choice",
            "to": "short_text",
            "provenance": "shannon-2026-09-02-call"
          }
        }
      },
      {
        "questionKey": "ever_smoked",
        "sectionKey": "social_and_basic_history",
        "sectionLabel": "Social and Basic History",
        "sequenceNumber": 36,
        "promptText": "Do you smoke now, or have you ever smoked or used cigars, a pipe, e-cigarettes, or vaping?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Do you smoke, or have you ever smoked",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "smoking_start_quit_year",
        "sectionKey": "social_and_basic_history",
        "sectionLabel": "Social and Basic History",
        "sequenceNumber": 37,
        "promptText": "When did you start smoking, and how long did you smoke — or do you still smoke?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "ever_smoked",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What year did you start smoking, and what year did you quit if you have quit",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "smoking_packs_per_day",
        "sectionKey": "social_and_basic_history",
        "sectionLabel": "Social and Basic History",
        "sequenceNumber": 38,
        "promptText": "On average, how many packs a day did you smoke, or do you smoke now?",
        "answerType": "number",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "ever_smoked",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "On average, how many packs per day did or do you smoke",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "only_if ever_smoked yes; review."
        }
      },
      {
        "questionKey": "drinks_alcohol",
        "sectionKey": "social_and_basic_history",
        "sectionLabel": "Social and Basic History",
        "sequenceNumber": 39,
        "promptText": "Do you drink alcohol?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Do you drink beer, wine, or liquor",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "alcohol_drinks_per_week",
        "sectionKey": "social_and_basic_history",
        "sectionLabel": "Social and Basic History",
        "sequenceNumber": 40,
        "promptText": "How many drinks do you usually have per week?",
        "answerType": "number",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "drinks_alcohol",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "How many drinks per week do you usually drink",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "recreational_or_street_drugs",
        "sectionKey": "social_and_basic_history",
        "sectionLabel": "Social and Basic History",
        "sequenceNumber": 41,
        "promptText": "Do you have a history of recreational or street drug use?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false,
          "trigger": "see evidence_note",
          "consequence": "see evidence_note"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "a history of recreational or street drug use",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "recreational_or_street_drugs_detail",
        "sectionKey": "social_and_basic_history",
        "sectionLabel": "Social and Basic History",
        "sequenceNumber": 42,
        "promptText": "Which drugs have you used?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "recreational_or_street_drugs",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Which drugs have you used",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview."
        }
      },
      {
        "questionKey": "recreational_or_street_drugs_last_use",
        "sectionKey": "social_and_basic_history",
        "sectionLabel": "Social and Basic History",
        "sequenceNumber": 43,
        "promptText": "When did you last use them?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "recreational_or_street_drugs",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "When did you last use them",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "only_if recreational_or_street_drugs yes; alwaysRequiresReview."
        }
      },
      {
        "questionKey": "body_piercing_other_than_earrings",
        "sectionKey": "social_and_basic_history",
        "sectionLabel": "Social and Basic History",
        "sequenceNumber": 44,
        "promptText": "Do you have any body piercing other than earrings?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any body piercing other than earrings",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "height_inches",
        "sectionKey": "social_and_basic_history",
        "sectionLabel": "Social and Basic History",
        "sequenceNumber": 45,
        "promptText": "How tall are you? You can tell me in feet and inches.",
        "answerType": "number",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "v2 NEW question (was §4.4 missing); voice prompt PROVISIONAL | v2: number (inches); manual UI renders ft/in selects; cal",
          "provenance": "VERBATIM"
        }
      },
      {
        "questionKey": "weight_pounds",
        "sectionKey": "social_and_basic_history",
        "sectionLabel": "Social and Basic History",
        "sequenceNumber": 46,
        "promptText": "What is your current weight in pounds?",
        "answerType": "number",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "v2 NEW question (was §4.4 missing); voice prompt PROVISIONAL",
          "provenance": "VERBATIM"
        }
      },
      {
        "questionKey": "preferred_pharmacy",
        "sectionKey": "social_and_basic_history",
        "sectionLabel": "Social and Basic History",
        "sequenceNumber": 47,
        "promptText": "Which pharmacy do you prefer to use?",
        "answerType": "short_text",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "v2 NEW question (was §4.4 missing); voice prompt PROVISIONAL",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "cardiac_system_umbrella",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 48,
        "promptText": "Do you have any heart or blood pressure problems — for example high blood pressure, a heart attack, heart failure, or an abnormal heart rhythm?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "umbrellaSection": "cardiovascular_review_of_systems",
          "provenance": "shannon-2026-08-12-umbrella-flow"
        }
      },
      {
        "questionKey": "angina",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 49,
        "promptText": "Have you had angina or heart-related chest pain?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "angina or heart-related chest pain",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "plainLanguageDefinition": "Angina means chest pain or pressure that can happen when the heart is not getting enough oxygen-rich blood.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "angina_detail",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 50,
        "promptText": "How often does it happen, and when did you last experience it?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "angina",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "How often does it happen, and when did you last experience it",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview."
        }
      },
      {
        "questionKey": "myocardial_infarction",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 51,
        "promptText": "Have you had a myocardial infarction, or heart attack?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "a myocardial infarction, or heart attack",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "plainLanguageDefinition": "A myocardial infarction is another term for a heart attack.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "myocardial_infarction_date",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 52,
        "promptText": "What was the approximate date of the heart attack?",
        "answerType": "date",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "myocardial_infarction",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What was the approximate date of the heart attack",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "congestive_heart_failure",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 53,
        "promptText": "Have you had congestive heart failure?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "congestive heart failure",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "yesRequiresReview.",
          "plainLanguageDefinition": "Congestive heart failure means the heart has trouble pumping blood as well as the body needs.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "abnormal_heart_rhythm",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 54,
        "promptText": "Have you had an abnormal heart rhythm?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "an abnormal heart rhythm",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "yesRequiresReview.",
          "plainLanguageDefinition": "An abnormal heart rhythm means the heartbeat can be too fast, too slow, or irregular.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "abnormal_heart_rhythm_type",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 55,
        "promptText": "What type of abnormal heart rhythm?",
        "answerType": "multi_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "a-fib",
            "bundle branch block",
            "heart block",
            "irregular heartbeat",
            "pvc",
            "svt",
            "v-tach",
            "unknown"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "abnormal_heart_rhythm",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {
          "options": [
            {
              "value": "a-fib",
              "label": "a-fib",
              "spokenAliases": [
                "atrial fibrillation",
                "afib"
              ]
            },
            {
              "value": "bundle branch block",
              "label": "bundle branch block",
              "spokenAliases": []
            },
            {
              "value": "heart block",
              "label": "heart block",
              "spokenAliases": []
            },
            {
              "value": "irregular heartbeat",
              "label": "irregular heartbeat",
              "spokenAliases": [
                "skips beats"
              ]
            },
            {
              "value": "pvc",
              "label": "pvc",
              "spokenAliases": [
                "premature beats"
              ]
            },
            {
              "value": "svt",
              "label": "svt",
              "spokenAliases": [
                "supraventricular tachycardia",
                "racing heart"
              ]
            },
            {
              "value": "v-tach",
              "label": "v-tach",
              "spokenAliases": [
                "ventricular tachycardia"
              ]
            },
            {
              "value": "unknown",
              "label": "unknown",
              "spokenAliases": [
                "not sure what kind"
              ]
            }
          ],
          "enumerateAloud": false,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": "What type of abnormal heart rhythm",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "only_if yes; review.",
          "optionsProvenance": "observed"
        }
      },
      {
        "questionKey": "cardiac_event_hospitalized",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 56,
        "promptText": "Were you ever hospitalized for it?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "abnormal_heart_rhythm",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "cardiac_event_treatment",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 57,
        "promptText": "How was it treated?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "abnormal_heart_rhythm",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "cardiac_event_last_date",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 58,
        "promptText": "When was the last time it caused you a problem?",
        "answerType": "date",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "abnormal_heart_rhythm",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "cardiac_event_unresolved",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 59,
        "promptText": "Is this heart rhythm problem still being treated or watched today? Yes or no.",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "abnormal_heart_rhythm",
            "equals": true
          }
        },
        "redFlagRules": {
          "reviewSignal": "red_flag",
          "unsureRequiresReview": true,
          "trigger": "unresolved/untreated cardiac",
          "consequence": "route-to-anesthesia"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "high_blood_pressure",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 60,
        "promptText": "Do you have high blood pressure?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "high blood pressure",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "high_blood_pressure_controlled",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 61,
        "promptText": "Is your high blood pressure well controlled with medication?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "high_blood_pressure",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "noRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Is your high blood pressure well controlled with medication",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "only_if yes; noRequiresReview."
        }
      },
      {
        "questionKey": "heart_valve_problems",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 62,
        "promptText": "Do you have heart valve problems?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "heart valve problems",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "vascular_disease",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 63,
        "promptText": "Do you have vascular disease?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "vascular disease",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "yesRequiresReview.",
          "plainLanguageDefinition": "Vascular disease means a problem with blood vessels or blood circulation.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "high_cholesterol_or_lipids",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 64,
        "promptText": "Do you have high cholesterol or lipids?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "high cholesterol or lipids",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "bypass_surgery",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 65,
        "promptText": "Have you had bypass surgery?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "bypass surgery",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "bypass_surgery_date",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 66,
        "promptText": "What was the date of the bypass surgery?",
        "answerType": "date",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "bypass_surgery",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What was the date of the bypass surgery",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "cardiovascular_other",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 67,
        "promptText": "Do you have any other cardiovascular history not covered?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other cardiovascular history not covered",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "cardiovascular_other_detail",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 68,
        "promptText": "Please describe the other cardiovascular history.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "cardiovascular_other",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe the other cardiovascular history",
        "questionMetadata": {
          "sourceSection": "H. Cardiovascular Review of Systems",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "pacemaker",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 69,
        "promptText": "Do you have a pacemaker?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "a pacemaker",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "pacemaker_manufacturer",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 70,
        "promptText": "Which company made your pacemaker?",
        "answerType": "single_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "medtronic",
            "boston scientific",
            "abbott",
            "biotronik",
            "other"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "pacemaker",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {
          "options": [
            {
              "value": "medtronic",
              "label": "medtronic",
              "spokenAliases": []
            },
            {
              "value": "boston scientific",
              "label": "boston scientific",
              "spokenAliases": []
            },
            {
              "value": "abbott",
              "label": "abbott",
              "spokenAliases": [
                "st jude",
                "st. jude"
              ]
            },
            {
              "value": "biotronik",
              "label": "biotronik",
              "spokenAliases": []
            },
            {
              "value": "other",
              "label": "other",
              "spokenAliases": [
                "unknown",
                "not sure"
              ]
            }
          ],
          "enumerateAloud": false,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "manufacturer per anesthesia requirement | key corrected 2026-07-19 (gate/follow-up mis-join)",
          "optionsProvenance": "authored",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "aicd",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 71,
        "promptText": "Do you have an AICD, an implanted cardiac defibrillator?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "an AICD, an implanted cardiac defibrillator",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "plainLanguageDefinition": "An AICD is an implanted cardiac defibrillator, a device that can treat dangerous heart rhythms.",
          "definitionStatus": "source_controlled_for_voice_help",
          "sourceNote": "Paper scan appears to read ACID; clinical interpretation is AICD / implanted cardiac defibrillator."
        }
      },
      {
        "questionKey": "cardiac_stent",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 72,
        "promptText": "Do you have a cardiac stent?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "cardiac_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "cardiovascular"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "a cardiac stent",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "cardiac_stent_drug_eluting",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 73,
        "promptText": "Is the cardiac stent drug eluting?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "cardiac_stent",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Is the cardiac stent drug eluting",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "only_if stent yes; review."
        }
      },
      {
        "questionKey": "cardiac_stent_date",
        "sectionKey": "cardiovascular_review_of_systems",
        "sectionLabel": "Cardiovascular Review of Systems",
        "sequenceNumber": 74,
        "promptText": "When was the stent placed?",
        "answerType": "date",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "cardiac_stent",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "When was the stent placed",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "only_if stent yes; review."
        }
      },
      {
        "questionKey": "pulmonary_system_umbrella",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 75,
        "promptText": "Do you have any breathing or lung problems — for example asthma, COPD or emphysema, sleep apnea, or a recent cough or cold?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "umbrellaSection": "pulmonary_review_of_systems",
          "provenance": "shannon-2026-08-12-umbrella-flow"
        }
      },
      {
        "questionKey": "emphysema_copd",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 76,
        "promptText": "Do you have emphysema or COPD?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "pulmonary_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "respiratory"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "emphysema or COPD",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "yesRequiresReview.",
          "plainLanguageDefinition": "COPD and emphysema are lung conditions that can make breathing harder.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "asthma",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 77,
        "promptText": "Do you have asthma?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "pulmonary_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "respiratory"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "asthma",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "asthma_rescue_inhaler",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 78,
        "promptText": "Do you use a rescue inhaler?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "asthma",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Do you use a rescue inhaler",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "only_if asthma yes; review."
        }
      },
      {
        "questionKey": "asthma_attack_last_date",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 79,
        "promptText": "What was the approximate date of your last asthma attack?",
        "answerType": "date",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "asthma",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What was the approximate date of your last asthma attack",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "only_if asthma yes; review."
        }
      },
      {
        "questionKey": "pneumonia_last_six_weeks",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 80,
        "promptText": "Have you had pneumonia in the last 6 weeks?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "pulmonary_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "respiratory"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "pneumonia in the last 6 weeks",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "home_oxygen_use",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 81,
        "promptText": "Do you use oxygen at home?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "pulmonary_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "respiratory"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false,
          "trigger": "see evidence_note",
          "consequence": "see evidence_note"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Do you use oxygen at home",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "home_o2_params",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 82,
        "promptText": "What oxygen flow rate are you prescribed?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "home_oxygen_use",
            "equals": true
          }
        },
        "redFlagRules": {
          "reviewSignal": "red_flag",
          "unsureRequiresReview": true,
          "trigger": "home oxygen",
          "consequence": "eligibility-note: VIP typically does not accept home-oxygen patients"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "home_o2_usage",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 83,
        "promptText": "Do you use it continuously, or only at certain times such as at night?",
        "answerType": "single_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "inline_options",
          "options": [
            "continuous",
            "intermittent"
          ]
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "continuous",
            "intermittent"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "home_oxygen_use",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {
          "options": [
            {
              "value": "continuous",
              "label": "continuous",
              "spokenAliases": [
                "all the time"
              ]
            },
            {
              "value": "intermittent",
              "label": "intermittent",
              "spokenAliases": [
                "only sometimes",
                "at night",
                "nocturnal"
              ]
            }
          ],
          "enumerateAloud": true,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "optionsProvenance": "authored",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "home_o2_portable",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 84,
        "promptText": "Do you have a portable oxygen machine you could bring with you?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "home_oxygen_use",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "sleep_apnea",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 85,
        "promptText": "Have you been diagnosed with sleep apnea?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "pulmonary_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "respiratory"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Have you been diagnosed with sleep apnea",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "cpap_bipap_use",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 86,
        "promptText": "Do you use a CPAP or BiPAP machine?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "sleep_apnea",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "noRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Do you use a CPAP or BiPAP machine",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "only_if sleep_apnea yes; noRequiresReview.",
          "plainLanguageDefinition": "CPAP and BiPAP are breathing machines used during sleep to help keep breathing steady.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "tuberculosis",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 87,
        "promptText": "Have you had tuberculosis?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "pulmonary_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "respiratory"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "tuberculosis",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "yesRequiresReview.",
          "plainLanguageDefinition": "Tuberculosis is an infection that most often affects the lungs.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "bronchitis",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 88,
        "promptText": "Have you had bronchitis?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "pulmonary_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "respiratory"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "bronchitis",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "shortness_of_breath",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 89,
        "promptText": "Do you have shortness of breath?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "pulmonary_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "respiratory"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "shortness of breath",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "recent_cough_or_cold",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 90,
        "promptText": "Do you have a recent cough or cold?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "pulmonary_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "respiratory"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "a recent cough or cold",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "illness_fever",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 91,
        "promptText": "Do you currently have a fever?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "recent_cough_or_cold",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "illness_onset_date",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 92,
        "promptText": "When did your symptoms start?",
        "answerType": "date",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "recent_cough_or_cold",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "illness_treatment",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 93,
        "promptText": "Are you treating it with anything?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "recent_cough_or_cold",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "illness_improving",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 94,
        "promptText": "Are you feeling better or about the same?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "recent_cough_or_cold",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "illness_surgeon_notified",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 95,
        "promptText": "Have you let your surgeon know you are feeling unwell?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "recent_cough_or_cold",
            "equals": true
          }
        },
        "redFlagRules": {
          "reviewSignal": "red_flag",
          "unsureRequiresReview": true,
          "trigger": "current illness near surgery",
          "consequence": "review-flag; possible-cancel per timing/stability"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "pulmonary_other",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 96,
        "promptText": "Do you have any other pulmonary or breathing history not covered?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "pulmonary_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "respiratory"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other pulmonary or breathing history not covered",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "pulmonary_other_detail",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 97,
        "promptText": "Please describe the other breathing history.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "pulmonary_other",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe the other breathing history",
        "questionMetadata": {
          "sourceSection": "I. Pulmonary Review of Systems",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "pulmonary_embolism_history",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 98,
        "promptText": "Have you ever had a pulmonary embolism — a blood clot in your lung?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "pulmonary_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "respiratory",
                  "bleeding_clotting"
                ]
              }
            ]
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "NO fixture match — new question for v2 (author in 0.2/0.3) | v2 NEW gate — OM asks this but the v1 call template never d",
          "provenance": "VERBATIM"
        }
      },
      {
        "questionKey": "pe_event_date",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 99,
        "promptText": "When did the blood clot in your lung happen?",
        "answerType": "date",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "pulmonary_embolism_history",
            "equals": true
          }
        },
        "redFlagRules": {
          "reviewSignal": "yellow_flag",
          "unsureRequiresReview": true,
          "trigger": "recent PE",
          "consequence": "review-flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "pe_treatment",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 100,
        "promptText": "How was it treated?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "pulmonary_embolism_history",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "pe_recurrence",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 101,
        "promptText": "Has it ever come back?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "pulmonary_embolism_history",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "pe_on_anticoagulation",
        "sectionKey": "pulmonary_review_of_systems",
        "sectionLabel": "Pulmonary Review of Systems",
        "sequenceNumber": 102,
        "promptText": "Are you currently taking a blood thinner for it?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "pulmonary_embolism_history",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "renal_system_umbrella",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 103,
        "promptText": "Do you have any kidney or urinary problems — for example kidney disease, kidney stones, or dialysis?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "umbrellaSection": "renal_hepatic_neurologic_gastrointestinal_endocrine",
          "provenance": "shannon-2026-08-12-umbrella-flow"
        }
      },
      {
        "questionKey": "kidney_stones",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 104,
        "promptText": "Have you had kidney stones?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "renal_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "renal"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "kidney stones",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "prostate_trouble",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 105,
        "promptText": "Have you had prostate trouble?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "renal_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "renal"
                ]
              }
            ],
            "patientSexAtBirthOneOf": [
              "male"
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "prostate trouble",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "urinary_incontinence",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 106,
        "promptText": "Do you have urinary incontinence?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "renal_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "renal"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "urinary incontinence",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "kidney_failure",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 107,
        "promptText": "Have you had kidney failure?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "renal_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "renal"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false,
          "trigger": "see evidence_note",
          "consequence": "see evidence_note"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "kidney failure",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "plainLanguageDefinition": "Kidney failure means the kidneys are not filtering blood as well as they should.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "kidney_failure_severity",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 108,
        "promptText": "How would you describe your kidney failure?",
        "answerType": "single_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "mild - not requiring dialysis",
            "moderate - followed by nephrologist",
            "on dialysis",
            "kidney transplant",
            "unknown"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "kidney_failure",
            "equals": true
          }
        },
        "redFlagRules": {
          "reviewSignal": "red_flag",
          "unsureRequiresReview": true,
          "trigger": "severity=on dialysis",
          "consequence": "red alert - may stop case (Shannon 23:44)"
        },
        "answerNormalization": {
          "options": [
            {
              "value": "mild - not requiring dialysis",
              "label": "mild - not requiring dialysis",
              "spokenAliases": [
                "mild"
              ]
            },
            {
              "value": "moderate - followed by nephrologist",
              "label": "moderate - followed by nephrologist",
              "spokenAliases": [
                "moderate",
                "sees kidney doctor"
              ]
            },
            {
              "value": "on dialysis",
              "label": "on dialysis",
              "spokenAliases": [
                "dialysis"
              ]
            },
            {
              "value": "kidney transplant",
              "label": "kidney transplant",
              "spokenAliases": [
                "transplant"
              ]
            },
            {
              "value": "unknown",
              "label": "unknown",
              "spokenAliases": [
                "not sure"
              ]
            }
          ],
          "enumerateAloud": false,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "re-keyed from renal_other_detail 2026-07-30 (workbook column offset). Gate was ALREADY REN-001=yes, i.e. kidney_failure ",
          "optionsProvenance": "authored",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "dialysis",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 109,
        "promptText": "Are you on dialysis?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "renal_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "renal"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Are you on dialysis",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "plainLanguageDefinition": "Dialysis is a treatment that helps filter the blood when the kidneys cannot do enough filtering.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "dialysis_detail",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 110,
        "promptText": "What type of dialysis do you have, and how often do you have dialysis?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "dialysis",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What type of dialysis do you have, and how often do you have dialysis",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview."
        }
      },
      {
        "questionKey": "renal_other",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 111,
        "promptText": "Do you have any other kidney or urinary history not covered?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "renal_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "renal"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other kidney or urinary history not covered",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "renal_other_detail",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 112,
        "promptText": "Please describe the other kidney or urinary history.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "renal_other",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe the other kidney or urinary history",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "hepatic_system_umbrella",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 113,
        "promptText": "Do you have any liver problems — for example hepatitis, cirrhosis, or jaundice?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "umbrellaSection": "renal_hepatic_neurologic_gastrointestinal_endocrine",
          "provenance": "shannon-2026-08-12-umbrella-flow"
        }
      },
      {
        "questionKey": "liver_failure_or_jaundice",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 114,
        "promptText": "Have you had liver failure or yellow jaundice?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "hepatic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "hepatic"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "liver failure or yellow jaundice",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "hepatitis",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 115,
        "promptText": "Have you had hepatitis?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "hepatic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "hepatic"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "hepatitis",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "hepatitis_type",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 116,
        "promptText": "What type of hepatitis?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "hepatitis",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What type of hepatitis",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "cirrhosis",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 117,
        "promptText": "Have you had cirrhosis?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "hepatic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "hepatic"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false,
          "trigger": "cirrhosis",
          "consequence": "red alert — may stop case (Shannon)"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "cirrhosis",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "plainLanguageDefinition": "Cirrhosis means long-term scarring of the liver.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "hepatic_other",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 118,
        "promptText": "Do you have any other liver history not covered?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "hepatic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "hepatic"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other liver history not covered",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "hepatic_other_detail",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 119,
        "promptText": "Please describe the other liver history.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "hepatic_other",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe the other liver history",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "neurologic_system_umbrella",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 120,
        "promptText": "Do you have any neurological problems — for example seizures, a stroke, migraines, or numbness and tingling?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "umbrellaSection": "renal_hepatic_neurologic_gastrointestinal_endocrine",
          "provenance": "shannon-2026-08-12-umbrella-flow"
        }
      },
      {
        "questionKey": "seizures",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 121,
        "promptText": "Have you had seizures?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "neurologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "neurological"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "seizures",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "plainLanguageDefinition": "A seizure is a sudden episode of abnormal electrical activity in the brain that can affect awareness, movement, or sensation.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "seizures_detail",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 122,
        "promptText": "What was the date of your last seizure, and how often do seizures happen: monthly, yearly, weekly, or another frequency?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "seizures",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What was the date of your last seizure, and how often do seizures happen: monthl",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview."
        }
      },
      {
        "questionKey": "seizure_last_date",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 123,
        "promptText": "When was your most recent seizure? The month and year is fine.",
        "answerType": "date",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "seizures",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "question_key assigned 2026-07-30. Ledger NEURO-001-A, VERBATIM, ocr_match_recall 1.00. CHR-041 (Christina 23:44-25:09): ",
          "provenance": "VERBATIM"
        }
      },
      {
        "questionKey": "seizure_type",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 124,
        "promptText": "What type of seizures do you have?",
        "answerType": "multi_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "grand mal or generalized tonic-clonic",
            "absence",
            "myoclonic",
            "clonic",
            "tonic",
            "atonic or drop",
            "febrile",
            "unsure"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "seizures",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {
          "options": [
            {
              "value": "grand mal or generalized tonic-clonic",
              "label": "grand mal or generalized tonic-clonic",
              "spokenAliases": [
                "grand mal",
                "convulsions",
                "full seizure"
              ]
            },
            {
              "value": "absence",
              "label": "absence",
              "spokenAliases": [
                "petit mal",
                "staring spells"
              ]
            },
            {
              "value": "myoclonic",
              "label": "myoclonic",
              "spokenAliases": [
                "muscle jerks"
              ]
            },
            {
              "value": "clonic",
              "label": "clonic",
              "spokenAliases": []
            },
            {
              "value": "tonic",
              "label": "tonic",
              "spokenAliases": []
            },
            {
              "value": "atonic or drop",
              "label": "atonic or drop",
              "spokenAliases": [
                "drop attack",
                "drop seizure"
              ]
            },
            {
              "value": "febrile",
              "label": "febrile",
              "spokenAliases": [
                "fever seizure"
              ]
            },
            {
              "value": "unsure",
              "label": "unsure",
              "spokenAliases": [
                "not sure",
                "unknown"
              ]
            }
          ],
          "enumerateAloud": false,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "re-keyed from dialysis_detail 2026-07-30 (workbook column offset: form_label/options were the seizure list, question_key",
          "optionsProvenance": "observed",
          "provenance": "VERBATIM"
        }
      },
      {
        "questionKey": "seizure_frequency",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 125,
        "promptText": "How often do seizures happen - weekly, monthly, yearly, or some other pattern?",
        "answerType": "single_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "inline_options",
          "options": [
            "weekly",
            "monthly",
            "yearly",
            "another pattern",
            "not sure"
          ]
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "weekly",
            "monthly",
            "yearly",
            "another pattern",
            "not sure"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "seizures",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {
          "options": [
            {
              "value": "weekly",
              "label": "weekly",
              "spokenAliases": []
            },
            {
              "value": "monthly",
              "label": "monthly",
              "spokenAliases": []
            },
            {
              "value": "yearly",
              "label": "yearly",
              "spokenAliases": []
            },
            {
              "value": "another pattern",
              "label": "another pattern",
              "spokenAliases": [
                "other",
                "something else"
              ]
            },
            {
              "value": "not sure",
              "label": "not sure",
              "spokenAliases": [
                "unsure",
                "unknown"
              ]
            }
          ],
          "enumerateAloud": true,
          "confirmationClass": "silent",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "re-keyed from seizures_detail 2026-07-30 (workbook column offset). OPTIONS ARE PROVISIONAL: ledger NEURO-001-C options_v",
          "optionsProvenance": "authored",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "stroke_tia",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 126,
        "promptText": "Have you had a stroke or mini-stroke, also called a TIA?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "neurologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "neurological"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "a stroke or mini-stroke, also called a TIA",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "plainLanguageDefinition": "A stroke or TIA can happen when blood flow to part of the brain is blocked or reduced. A TIA is sometimes called a mini-stroke.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "stroke_tia_date",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 127,
        "promptText": "What was the approximate date of the stroke or TIA?",
        "answerType": "date",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "stroke_tia",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What was the approximate date of the stroke or TIA",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "neuropathy",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 128,
        "promptText": "Do you have neuropathy?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "neurologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "neurological"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "neuropathy",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview.",
          "plainLanguageDefinition": "Neuropathy means nerve damage or nerve irritation that can cause numbness, tingling, burning, or weakness.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "frequent_migraines",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 129,
        "promptText": "Do you have frequent migraines that require treatment?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "neurologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "neurological"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "frequent migraines that require treatment",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "paralysis_neuro",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 130,
        "promptText": "Do you have paralysis?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "neurologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "neurological"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "paralysis",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "alzheimers",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 131,
        "promptText": "Do you have Alzheimer's disease?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "neurologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "neurological"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Alzheimer's disease",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "parkinsons",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 132,
        "promptText": "Do you have Parkinson's disease?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "neurologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "neurological"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Parkinson's disease",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "neurologic_other",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 133,
        "promptText": "Do you have any other neurological history not covered?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "neurologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "neurological"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other neurological history not covered",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "neurologic_other_detail",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 134,
        "promptText": "Please describe the other neurological history.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "neurologic_other",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe the other neurological history",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "gastrointestinal_system_umbrella",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 135,
        "promptText": "Do you have any stomach or digestive problems — for example ulcers, acid reflux, or a hiatal hernia?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "umbrellaSection": "renal_hepatic_neurologic_gastrointestinal_endocrine",
          "provenance": "shannon-2026-08-12-umbrella-flow"
        }
      },
      {
        "questionKey": "stomach_ulcers",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 136,
        "promptText": "Have you had stomach ulcers?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "gastrointestinal_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "gastrointestinal"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "stomach ulcers",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "acid_reflux_heartburn",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 137,
        "promptText": "Do you have frequent acid reflux or heartburn?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "gastrointestinal_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "gastrointestinal"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "frequent acid reflux or heartburn",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "hiatal_hernia",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 138,
        "promptText": "Do you have a hiatal hernia of the stomach?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "gastrointestinal_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "gastrointestinal"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "a hiatal hernia of the stomach",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview.",
          "plainLanguageDefinition": "A hiatal hernia means part of the stomach pushes upward through the diaphragm.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "gastrointestinal_other",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 139,
        "promptText": "Do you have any other stomach or gastrointestinal history not covered?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "gastrointestinal_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "gastrointestinal"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other stomach or gastrointestinal history not covered",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "gastrointestinal_other_detail",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 140,
        "promptText": "Please describe the other stomach or gastrointestinal history.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "gastrointestinal_other",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe the other stomach or gastrointestinal history",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "endocrine_system_umbrella",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 141,
        "promptText": "Do you have any endocrine or metabolic conditions — for example diabetes or a thyroid problem?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "umbrellaSection": "renal_hepatic_neurologic_gastrointestinal_endocrine",
          "provenance": "shannon-2026-08-12-umbrella-flow"
        }
      },
      {
        "questionKey": "thyroid_disease",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 142,
        "promptText": "Do you have thyroid disease?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "endocrine_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "endocrine_metabolic"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "thyroid disease",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview.",
          "plainLanguageDefinition": "Thyroid disease means the thyroid gland may make too much or too little thyroid hormone.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "thyroid_type",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 143,
        "promptText": "Is it low thyroid, high thyroid, or another thyroid condition?",
        "answerType": "single_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "inline_options",
          "options": [
            "low thyroid",
            "high thyroid",
            "other thyroid disease",
            "none of these"
          ]
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "low thyroid",
            "high thyroid",
            "other thyroid disease",
            "none of these"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "thyroid_disease",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {
          "options": [
            {
              "value": "low thyroid",
              "label": "low thyroid",
              "spokenAliases": [
                "hypothyroid",
                "underactive"
              ]
            },
            {
              "value": "high thyroid",
              "label": "high thyroid",
              "spokenAliases": [
                "hyperthyroid",
                "overactive",
                "graves"
              ]
            },
            {
              "value": "other thyroid disease",
              "label": "other thyroid disease",
              "spokenAliases": [
                "nodules",
                "goiter"
              ]
            },
            {
              "value": "none of these",
              "label": "none of these",
              "spokenAliases": []
            }
          ],
          "enumerateAloud": true,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "only_if yes; options low thyroid, high thyroid, other.",
          "optionsProvenance": "authored"
        }
      },
      {
        "questionKey": "diabetes",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 144,
        "promptText": "Do you have diabetes?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "endocrine_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "endocrine_metabolic"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "diabetes",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "diabetes_type",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 145,
        "promptText": "Is it insulin-dependent diabetes or non-insulin-dependent diabetes?",
        "answerType": "single_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "insulin dependent",
            "non-insulin dependent"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "diabetes",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {
          "options": [
            {
              "value": "insulin dependent",
              "label": "insulin dependent",
              "spokenAliases": [
                "insulin",
                "type 1"
              ]
            },
            {
              "value": "non-insulin dependent",
              "label": "non-insulin dependent",
              "spokenAliases": [
                "non insulin",
                "type 2",
                "tablets"
              ]
            }
          ],
          "enumerateAloud": false,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "only_if yes; options insulin dependent, non-insulin dependent.",
          "optionsProvenance": "authored"
        }
      },
      {
        "questionKey": "endocrine_other",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 146,
        "promptText": "Do you have any other endocrine history not covered?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "endocrine_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "endocrine_metabolic"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other endocrine history not covered",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "endocrine_other_detail",
        "sectionKey": "renal_hepatic_neurologic_gastrointestinal_endocrine",
        "sectionLabel": "Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
        "sequenceNumber": 147,
        "promptText": "Please describe the other endocrine history.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "endocrine_other",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe the other endocrine history",
        "questionMetadata": {
          "sourceSection": "J. Renal, Hepatic, Neurologic, Gastrointestinal, Endocrine",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "cancer_history",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 148,
        "promptText": "Have you had cancer?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "cancer",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "cancer_detail",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 149,
        "promptText": "What type of cancer?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "cancer_history",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What type of cancer",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "only_if yes; review.",
          "optionsRef": "@standard:cancer_types"
        }
      },
      {
        "questionKey": "cancer_diagnosis_date",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 150,
        "promptText": "When were you diagnosed?",
        "answerType": "date",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "cancer_history",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "cancer_last_treatment_date",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 151,
        "promptText": "When was your most recent treatment?",
        "answerType": "date",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "cancer_history",
            "equals": true
          }
        },
        "redFlagRules": {
          "reviewSignal": "yellow_flag",
          "unsureRequiresReview": true,
          "trigger": "treatment in last 30 days",
          "consequence": "review-flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "cancer_treatment_type",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 152,
        "promptText": "What kind of treatment have you had — for example chemotherapy, radiation, or surgery?",
        "answerType": "multi_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "chemotherapy",
            "radiation",
            "surgery",
            "immunotherapy",
            "hormone therapy",
            "none"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "cancer_history",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {
          "options": [
            {
              "value": "chemotherapy",
              "label": "chemotherapy",
              "spokenAliases": [
                "chemo"
              ]
            },
            {
              "value": "radiation",
              "label": "radiation",
              "spokenAliases": []
            },
            {
              "value": "surgery",
              "label": "surgery",
              "spokenAliases": []
            },
            {
              "value": "immunotherapy",
              "label": "immunotherapy",
              "spokenAliases": []
            },
            {
              "value": "hormone therapy",
              "label": "hormone therapy",
              "spokenAliases": []
            },
            {
              "value": "none",
              "label": "none",
              "spokenAliases": [
                "no treatment"
              ]
            }
          ],
          "enumerateAloud": false,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "optionsProvenance": "authored",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "cancer_current_status",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 153,
        "promptText": "How would you describe it today — in treatment, in remission, or being monitored?",
        "answerType": "single_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "inline_options",
          "options": [
            "in treatment",
            "remission",
            "monitored"
          ]
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "in treatment",
            "remission",
            "monitored"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "cancer_history",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {
          "options": [
            {
              "value": "in treatment",
              "label": "in treatment",
              "spokenAliases": [
                "active"
              ]
            },
            {
              "value": "remission",
              "label": "remission",
              "spokenAliases": [
                "cancer free"
              ]
            },
            {
              "value": "monitored",
              "label": "monitored",
              "spokenAliases": [
                "watch and wait"
              ]
            }
          ],
          "enumerateAloud": true,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "optionsProvenance": "authored",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "infectious_system_umbrella",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 154,
        "promptText": "Do you have any infectious disease history — for example MRSA, HIV, or hepatitis exposure?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "umbrellaSection": "oncologic_infectious_disease_and_hematologic",
          "provenance": "shannon-2026-09-01-content-session"
        }
      },
      {
        "questionKey": "mrsa_history",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 155,
        "promptText": "Have you had MRSA?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "infectious_system_umbrella",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "MRSA",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "plainLanguageDefinition": "MRSA is a type of bacteria that can be resistant to some antibiotics.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "infectious_other",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 156,
        "promptText": "Do you have any other infectious disease history or symptoms not covered?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "infectious_system_umbrella",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other infectious disease history or symptoms not covered",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "hiv_or_aids",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 157,
        "promptText": "Do you have HIV or AIDS?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "infectious_system_umbrella",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "HIV or AIDS",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "yesRequiresReview.",
          "plainLanguageDefinition": "HIV is a virus that affects the immune system. AIDS is an advanced stage of HIV infection.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "infectious_other_detail",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 158,
        "promptText": "Please describe the other infectious disease history or symptoms.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "infectious_other",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe the other infectious disease history or symptoms",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "mrsa_detail",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 159,
        "promptText": "What was the date, and how was it treated?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "mrsa_history",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What was the date, and how was it treated",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview."
        }
      },
      {
        "questionKey": "recent_infectious_symptoms_7_days",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 160,
        "promptText": "Within the last 7 days, have you had fever, cough, shortness of breath, fatigue, sore throat, repeated shaking with chills, loss of taste or smell, nausea, or vomiting?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Within the last 7 days, have you had fever, cough, shortness of breath, fatigue,",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "hematologic_system_umbrella",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 161,
        "promptText": "Do you have any blood problems — for example anemia, blood clots, or a bleeding or clotting disorder?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "umbrellaSection": "oncologic_infectious_disease_and_hematologic",
          "provenance": "shannon-2026-08-12-umbrella-flow"
        }
      },
      {
        "questionKey": "anemia",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 162,
        "promptText": "Do you have anemia?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "hematologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "bleeding_clotting"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "anemia",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "blood_clots_history",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 163,
        "promptText": "Do you or an immediate family member have a history of blood clots?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "hematologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "bleeding_clotting"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Do you or an immediate family member have a history of blood clots",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "blood_clots_who",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 164,
        "promptText": "Who had blood clots?",
        "answerType": "multi_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "self",
            "immediate family"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "blood_clots_history",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {
          "options": [
            {
              "value": "self",
              "label": "self",
              "spokenAliases": [
                "me",
                "myself"
              ]
            },
            {
              "value": "immediate family",
              "label": "immediate family",
              "spokenAliases": [
                "mother",
                "father",
                "sibling",
                "parent"
              ]
            }
          ],
          "enumerateAloud": false,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": "Who had blood clots",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "only_if yes; review.",
          "optionsProvenance": "observed"
        }
      },
      {
        "questionKey": "bleeding_or_clotting_disorder",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 165,
        "promptText": "Do you have a bleeding or blood clotting disorder?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "hematologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "bleeding_clotting"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "a bleeding or blood clotting disorder",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag.",
          "plainLanguageDefinition": "A bleeding or clotting disorder means blood may not clot normally, or may clot too easily.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "bleeding_or_clotting_disorder_name",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 166,
        "promptText": "What is the name of the disorder?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "bleeding_or_clotting_disorder",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What is the name of the disorder",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "only_if yes; alwaysRequiresReview."
        }
      },
      {
        "questionKey": "blood_transfusion",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 167,
        "promptText": "Have you had a blood transfusion?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "hematologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "bleeding_clotting"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "a blood transfusion",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "hematologic_other",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 168,
        "promptText": "Do you have any other blood-related history not covered?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "hematologic_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "bleeding_clotting"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other blood-related history not covered",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "hematologic_other_detail",
        "sectionKey": "oncologic_infectious_disease_and_hematologic",
        "sectionLabel": "Oncologic, Infectious Disease, and Hematologic",
        "sequenceNumber": 169,
        "promptText": "Please describe the other blood-related history.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "hematologic_other",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe the other blood-related history",
        "questionMetadata": {
          "sourceSection": "K. Oncologic, Infectious Disease, and Hematologic",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "musculoskeletal_problems",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 170,
        "promptText": "Do you have musculoskeletal problems?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "musculoskeletal problems",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "arthritis",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 171,
        "promptText": "Do you have arthritis?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "musculoskeletal_problems",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "musculoskeletal_pain"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "arthritis",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "arthritis_type",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 172,
        "promptText": "Is it rheumatoid arthritis, osteoarthritis, or another type?",
        "answerType": "single_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "rheumatoid",
            "osteoarthritis",
            "other"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "arthritis",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {
          "options": [
            {
              "value": "rheumatoid",
              "label": "rheumatoid",
              "spokenAliases": [
                "rheumatoid arthritis",
                "ra"
              ]
            },
            {
              "value": "osteoarthritis",
              "label": "osteoarthritis",
              "spokenAliases": [
                "osteo",
                "wear and tear"
              ]
            },
            {
              "value": "other",
              "label": "other",
              "spokenAliases": []
            }
          ],
          "enumerateAloud": false,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "only_if yes; options rheumatoid, osteoarthritis, other.",
          "optionsProvenance": "observed"
        }
      },
      {
        "questionKey": "chronic_low_back_pain",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 173,
        "promptText": "Do you have chronic low back pain?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "musculoskeletal_problems",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "musculoskeletal_pain"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "chronic low back pain",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "neck_or_jaw_problems",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 174,
        "promptText": "Do you have neck or jaw problems?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "musculoskeletal_problems",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "musculoskeletal_pain"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "neck or jaw problems",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "muscular_dystrophy",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 175,
        "promptText": "Do you have muscular dystrophy?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "musculoskeletal_problems",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "musculoskeletal_pain"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "muscular dystrophy",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "paralysis_musculoskeletal",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 176,
        "promptText": "Do you have paralysis related to a musculoskeletal condition?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "musculoskeletal_problems",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "musculoskeletal_pain"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "paralysis related to a musculoskeletal condition",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "paralysis_musculoskeletal_location",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 177,
        "promptText": "What is the location of the paralysis?",
        "answerType": "multi_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "abdomen",
            "chest",
            "upper back",
            "lower back",
            "neck",
            "head",
            "right arm",
            "left arm",
            "right leg",
            "left leg",
            "right foot",
            "left foot",
            "other"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "paralysis_musculoskeletal",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {
          "options": [
            {
              "value": "abdomen",
              "label": "abdomen",
              "spokenAliases": [
                "belly",
                "stomach"
              ]
            },
            {
              "value": "chest",
              "label": "chest",
              "spokenAliases": []
            },
            {
              "value": "upper back",
              "label": "upper back",
              "spokenAliases": []
            },
            {
              "value": "lower back",
              "label": "lower back",
              "spokenAliases": []
            },
            {
              "value": "neck",
              "label": "neck",
              "spokenAliases": []
            },
            {
              "value": "head",
              "label": "head",
              "spokenAliases": []
            },
            {
              "value": "right arm",
              "label": "right arm",
              "spokenAliases": []
            },
            {
              "value": "left arm",
              "label": "left arm",
              "spokenAliases": []
            },
            {
              "value": "right leg",
              "label": "right leg",
              "spokenAliases": []
            },
            {
              "value": "left leg",
              "label": "left leg",
              "spokenAliases": []
            },
            {
              "value": "right foot",
              "label": "right foot",
              "spokenAliases": []
            },
            {
              "value": "left foot",
              "label": "left foot",
              "spokenAliases": []
            },
            {
              "value": "other",
              "label": "other",
              "spokenAliases": []
            }
          ],
          "enumerateAloud": false,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": "What is the location of the paralysis",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "only_if yes; review.",
          "optionsProvenance": "observed"
        }
      },
      {
        "questionKey": "musculoskeletal_other",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 178,
        "promptText": "Do you have any other musculoskeletal history not covered?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "musculoskeletal_problems",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "musculoskeletal_pain"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other musculoskeletal history not covered",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "musculoskeletal_other_detail",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 179,
        "promptText": "Please describe the other musculoskeletal history.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "musculoskeletal_other",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe the other musculoskeletal history",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "metal_implants",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 180,
        "promptText": "Do you have metal plates, screws, rods, wires, or pins implanted?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "musculoskeletal_problems",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "musculoskeletal_pain"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "metal plates, screws, rods, wires, or pins implanted",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "metal_implants_detail",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 181,
        "promptText": "What type of implant do you have, and where is it located?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "metal_implants",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What type of implant do you have, and where is it located",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "internal_nerve_stimulator",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 182,
        "promptText": "Do you have an internal nerve stimulator?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "musculoskeletal_problems",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "musculoskeletal_pain"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "an internal nerve stimulator",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "mobility_problems",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 183,
        "promptText": "Do you have any problems with mobility — for example, do you use a wheelchair, cane, or walker?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any problems with mobility, such as using a wheelchair, cane, or walker, or issu",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "mobility_problem_detail",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 184,
        "promptText": "What device do you use, or what is the mobility problem?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "mobility_problems",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What device do you use, or what is the mobility problem",
        "questionMetadata": {
          "sourceSection": "G. Social and Basic History",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "activity_level",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 185,
        "promptText": "Which activity level best describes you?",
        "answerType": "single_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "inline_options",
          "options": [
            "unable to walk far",
            "walk around the house and short distances",
            "able to bike or walk 1 mile",
            "able to run 2 miles or more"
          ]
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "unable to walk far",
            "walk around the house and short distances",
            "able to bike or walk 1 mile",
            "able to run 2 miles or more"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "mobility_problems",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {
          "options": [
            {
              "value": "unable to walk far",
              "label": "unable to walk far",
              "spokenAliases": [
                "mostly housebound"
              ]
            },
            {
              "value": "walk around the house and short distances",
              "label": "walk around the house and short distances",
              "spokenAliases": [
                "light activity"
              ]
            },
            {
              "value": "able to bike or walk 1 mile",
              "label": "able to bike or walk 1 mile",
              "spokenAliases": [
                "moderate activity"
              ]
            },
            {
              "value": "able to run 2 miles or more",
              "label": "able to run 2 miles or more",
              "spokenAliases": [
                "very active",
                "run"
              ]
            }
          ],
          "enumerateAloud": true,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "choice split out of the gate question (review fix)",
          "optionsProvenance": "authored",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "chronic_pain",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 186,
        "promptText": "Do you have chronic pain?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "chronic pain",
        "questionMetadata": {
          "sourceSection": "M. OB/GYN, Pain, Pediatric, and Final Comments",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "chronic_pain_score",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 187,
        "promptText": "On a scale from 1 to 10, what is your pain score?",
        "answerType": "number",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "chronic_pain",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "On a scale from 1 to 10, what is your pain score",
        "questionMetadata": {
          "sourceSection": "M. OB/GYN, Pain, Pediatric, and Final Comments",
          "sourceReviewNote": "only_if chronic_pain yes; review."
        }
      },
      {
        "questionKey": "psychiatric_system_umbrella",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 188,
        "promptText": "Do you have any mental health conditions — for example depression, anxiety, bipolar disorder, or PTSD?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "umbrellaSection": "musculoskeletal_and_psychiatric",
          "provenance": "shannon-2026-08-12-umbrella-flow"
        }
      },
      {
        "questionKey": "bipolar_disorder",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 189,
        "promptText": "Do you have bipolar disorder?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "psychiatric_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "psychiatric"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "bipolar disorder",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "schizophrenia",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 190,
        "promptText": "Do you have schizophrenia?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "psychiatric_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "psychiatric"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "schizophrenia",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "depression",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 191,
        "promptText": "Do you have depression?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "psychiatric_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "psychiatric"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "depression",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "panic_anxiety_attacks",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 192,
        "promptText": "Do you have panic or anxiety attacks?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "psychiatric_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "psychiatric"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "panic or anxiety attacks",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "autism",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 193,
        "promptText": "Do you have autism?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "psychiatric_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "psychiatric"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "autism",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview.",
          "plainLanguageDefinition": "Autism is a neurodevelopmental condition that can affect communication, sensory processing, and routines.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "ptsd",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 194,
        "promptText": "Do you have post-traumatic stress disorder, or PTSD?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "psychiatric_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "psychiatric"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "post-traumatic stress disorder, or PTSD",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview.",
          "plainLanguageDefinition": "PTSD stands for post-traumatic stress disorder, a condition that can happen after trauma.",
          "definitionStatus": "source_controlled_for_voice_help"
        }
      },
      {
        "questionKey": "psychiatric_other",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 195,
        "promptText": "Do you have any other psychiatric history not covered?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "anyOf": [
              {
                "questionKey": "psychiatric_system_umbrella",
                "equals": true
              },
              {
                "questionKey": "medication_system_categories",
                "containsAny": [
                  "psychiatric"
                ]
              }
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "any other psychiatric history not covered",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "psychiatric_other_detail",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 196,
        "promptText": "Please describe the other psychiatric history.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "psychiatric_other",
            "equals": true
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please describe the other psychiatric history",
        "questionMetadata": {
          "sourceSection": "L. Musculoskeletal and Psychiatric",
          "sourceReviewNote": "only_if yes; review."
        }
      },
      {
        "questionKey": "skin_breakdown_open_wounds",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 197,
        "promptText": "Do you currently have any skin breakdown, rashes, or open wounds?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "NO fixture match — new question for v2 (author in 0.2/0.3) | v2 NEW gate — OM asks this but the v1 call template never d",
          "provenance": "VERBATIM"
        }
      },
      {
        "questionKey": "wound_near_surgical_site",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 198,
        "promptText": "Is the wound anywhere near where your surgery will be?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "skin_breakdown_open_wounds",
            "equals": true
          }
        },
        "redFlagRules": {
          "reviewSignal": "yellow_flag",
          "unsureRequiresReview": true,
          "trigger": "wound near surgical site",
          "consequence": "review-flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "wound_type",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 199,
        "promptText": "How would you describe it — a scrape, a rash, an open sore, or something else?",
        "answerType": "single_choice",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {
          "options": [
            "scrape",
            "rash",
            "open sore",
            "surgical wound",
            "other"
          ]
        },
        "skipLogic": {
          "onlyIf": {
            "questionKey": "skin_breakdown_open_wounds",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {
          "options": [
            {
              "value": "scrape",
              "label": "scrape",
              "spokenAliases": [
                "abrasion"
              ]
            },
            {
              "value": "rash",
              "label": "rash",
              "spokenAliases": []
            },
            {
              "value": "open sore",
              "label": "open sore",
              "spokenAliases": [
                "ulcer",
                "open wound"
              ]
            },
            {
              "value": "surgical wound",
              "label": "surgical wound",
              "spokenAliases": [
                "incision"
              ]
            },
            {
              "value": "other",
              "label": "other",
              "spokenAliases": []
            }
          ],
          "enumerateAloud": false,
          "confirmationClass": "confirm_back",
          "unlistedPolicy": "capture_verbatim"
        },
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "optionsProvenance": "authored",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "wound_infection_signs",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 200,
        "promptText": "Is it red, warm, swollen, or draining?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "skin_breakdown_open_wounds",
            "equals": true
          }
        },
        "redFlagRules": {
          "reviewSignal": "yellow_flag",
          "unsureRequiresReview": true,
          "trigger": "possible infected wound",
          "consequence": "review-flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "wound_treatment",
        "sectionKey": "musculoskeletal_and_psychiatric",
        "sectionLabel": "Musculoskeletal and Psychiatric",
        "sequenceNumber": 201,
        "promptText": "Are you treating it with anything?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "skin_breakdown_open_wounds",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "currently_pregnant",
        "sectionKey": "ob_gyn_pain_pediatric_and_final_comments",
        "sectionLabel": "OB/GYN, Pain, Pediatric, and Final Comments",
        "sequenceNumber": 202,
        "promptText": "Are you currently pregnant?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "patientAgeYearsAtLeast": 10,
            "patientAgeYearsAtMost": 60,
            "patientSexAtBirthOneOf": [
              "female"
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "red_flag",
          "yesRequiresReview": true,
          "treatAsRedFlag": true,
          "stopRoutineAutomation": false
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Are you currently pregnant",
        "questionMetadata": {
          "sourceSection": "M. OB/GYN, Pain, Pediatric, and Final Comments",
          "sourceReviewNote": "yesRequiresReview, treatAsRedFlag."
        }
      },
      {
        "questionKey": "last_menstrual_period_date",
        "sectionKey": "ob_gyn_pain_pediatric_and_final_comments",
        "sectionLabel": "OB/GYN, Pain, Pediatric, and Final Comments",
        "sequenceNumber": 203,
        "promptText": "What was the date of your last menstrual period, or say not applicable?",
        "answerType": "date",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "patientAgeYearsAtLeast": 10,
            "patientAgeYearsAtMost": 60,
            "patientSexAtBirthOneOf": [
              "female"
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "What was the date of your last menstrual period, or say not applicable",
        "questionMetadata": {
          "sourceSection": "M. OB/GYN, Pain, Pediatric, and Final Comments",
          "sourceReviewNote": "ask when clinically applicable; review if answered."
        }
      },
      {
        "questionKey": "hysterectomy",
        "sectionKey": "ob_gyn_pain_pediatric_and_final_comments",
        "sectionLabel": "OB/GYN, Pain, Pediatric, and Final Comments",
        "sequenceNumber": 204,
        "promptText": "Have you had a hysterectomy?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "patientAgeYearsAtLeast": 10,
            "patientAgeYearsAtMost": 60,
            "patientSexAtBirthOneOf": [
              "female"
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "a hysterectomy",
        "questionMetadata": {
          "sourceSection": "M. OB/GYN, Pain, Pediatric, and Final Comments",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "bilateral_tubal_ligation",
        "sectionKey": "ob_gyn_pain_pediatric_and_final_comments",
        "sectionLabel": "OB/GYN, Pain, Pediatric, and Final Comments",
        "sequenceNumber": 205,
        "promptText": "Have you had a bilateral tubal ligation?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "patientAgeYearsAtLeast": 10,
            "patientAgeYearsAtMost": 60,
            "patientSexAtBirthOneOf": [
              "female"
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "a bilateral tubal ligation",
        "questionMetadata": {
          "sourceSection": "M. OB/GYN, Pain, Pediatric, and Final Comments",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "menopause",
        "sectionKey": "ob_gyn_pain_pediatric_and_final_comments",
        "sectionLabel": "OB/GYN, Pain, Pediatric, and Final Comments",
        "sequenceNumber": 206,
        "promptText": "Have you gone through menopause?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "patientAgeYearsAtLeast": 10,
            "patientAgeYearsAtMost": 60,
            "patientSexAtBirthOneOf": [
              "female"
            ]
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "yesRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Have you gone through menopause",
        "questionMetadata": {
          "sourceSection": "M. OB/GYN, Pain, Pediatric, and Final Comments",
          "sourceReviewNote": "yesRequiresReview."
        }
      },
      {
        "questionKey": "child_growth_normal",
        "sectionKey": "ob_gyn_pain_pediatric_and_final_comments",
        "sectionLabel": "OB/GYN, Pain, Pediatric, and Final Comments",
        "sequenceNumber": 207,
        "promptText": "For this child patient, has growth and development been normal?",
        "answerType": "yes_no",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "patientAgeYearsAtMost": 17
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "noRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "For this child patient, has growth and development been normal",
        "questionMetadata": {
          "sourceSection": "M. OB/GYN, Pain, Pediatric, and Final Comments",
          "sourceReviewNote": "pediatric only; noRequiresReview."
        }
      },
      {
        "questionKey": "child_abnormalities_detail",
        "sectionKey": "ob_gyn_pain_pediatric_and_final_comments",
        "sectionLabel": "OB/GYN, Pain, Pediatric, and Final Comments",
        "sequenceNumber": 208,
        "promptText": "Please explain the abnormalities.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "child_growth_normal",
            "equals": false,
            "patientAgeYearsAtMost": 17
          }
        },
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Please explain the abnormalities",
        "questionMetadata": {
          "sourceSection": "M. OB/GYN, Pain, Pediatric, and Final Comments",
          "sourceReviewNote": "pediatric only and only_if previous no; review."
        }
      },
      {
        "questionKey": "additional_comments_or_history",
        "sectionKey": "ob_gyn_pain_pediatric_and_final_comments",
        "sectionLabel": "OB/GYN, Pain, Pediatric, and Final Comments",
        "sequenceNumber": 209,
        "promptText": "Is there any additional comment or health history that we have not addressed?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "alwaysRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "Is there any additional comment or health history that we have not addressed",
        "questionMetadata": {
          "sourceSection": "M. OB/GYN, Pain, Pediatric, and Final Comments",
          "sourceReviewNote": "optional; alwaysRequiresReview if answered."
        }
      },
      {
        "questionKey": "patient_attestation",
        "sectionKey": "ob_gyn_pain_pediatric_and_final_comments",
        "sectionLabel": "OB/GYN, Pain, Pediatric, and Final Comments",
        "sequenceNumber": 210,
        "promptText": "To confirm, are the answers you gave today complete and accurate to the best of your knowledge?",
        "answerType": "confirmation",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "initial_binary_only"
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "unsureRequiresReview": true,
          "reviewSignal": "yellow_flag",
          "noRequiresReview": true
        },
        "answerNormalization": {},
        "clinicianReviewLabel": "To confirm, are the answers you gave today complete and accurate to the best of ",
        "questionMetadata": {
          "sourceSection": "M. OB/GYN, Pain, Pediatric, and Final Comments",
          "sourceReviewNote": "noRequiresReview."
        }
      },
      {
        "questionKey": "conditions_without_medication",
        "sectionKey": "ob_gyn_pain_pediatric_and_final_comments",
        "sectionLabel": "OB/GYN, Pain, Pediatric, and Final Comments",
        "sequenceNumber": 211,
        "promptText": "Is there any health condition you have that we have not talked about — including anything you do not take medication for, like being pre-diabetic?",
        "answerType": "yes_no",
        "required": true,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {
          "reviewSignal": "yellow_flag",
          "unsureRequiresReview": true,
          "trigger": "unmedicated condition",
          "consequence": "review-flag"
        },
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM. Safety net per Shannon/Christina — untreated conditions must be captured.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "conditions_without_medication_detail",
        "sectionKey": "ob_gyn_pain_pediatric_and_final_comments",
        "sectionLabel": "OB/GYN, Pain, Pediatric, and Final Comments",
        "sequenceNumber": 212,
        "promptText": "Tell me about that condition.",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {
          "onlyIf": {
            "questionKey": "conditions_without_medication",
            "equals": true
          }
        },
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM.",
          "provenance": "PROVISIONAL"
        }
      },
      {
        "questionKey": "patient_questions_for_team",
        "sectionKey": "ob_gyn_pain_pediatric_and_final_comments",
        "sectionLabel": "OB/GYN, Pain, Pediatric, and Final Comments",
        "sequenceNumber": 213,
        "promptText": "Do you have any questions about your upcoming procedure that you would like us to pass to the team?",
        "answerType": "short_text",
        "required": false,
        "voicePhraseConfig": {
          "answerHintBehavior": "none",
          "options": []
        },
        "dtmfConfig": {},
        "validationRules": {},
        "skipLogic": {},
        "redFlagRules": {},
        "answerNormalization": {},
        "clinicianReviewLabel": null,
        "questionMetadata": {
          "sourceSection": "content workbook (v2 delta)",
          "sourceReviewNote": "BEYOND_OM. operational_only candidate — review screen, not chart pack",
          "provenance": "PROVISIONAL"
        }
      }
    ]
  },
  "integrity": {
    "note": "draft — integrity checksums are recomputed at publish time",
    "sectionCount": 13,
    "questionCount": 213
  }
}`;

const bindingsJsonText = String.raw`{
  "schemaVersion": "vip-one-mnet-bindings-v2-draft",
  "generatedFrom": "packages/contracts/fixtures/outbound-questionnaires/vip-questionnaire-workbook.csv",
  "bindings": [
    {
      "questionKey": "representative_name_relationship",
      "fieldPath": "clinical.questionnaireAnswers.representative_name_relationship",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "demographic-insurance",
        "fieldPath": "lastName"
      }
    },
    {
      "questionKey": "confirm_planned_procedure",
      "fieldPath": "clinical.questionnaireAnswers.confirm_planned_procedure",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "confirm_surgeon",
      "fieldPath": "clinical.questionnaireAnswers.confirm_surgeon",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "confirm_scheduled_date",
      "fieldPath": "clinical.questionnaireAnswers.confirm_scheduled_date",
      "transform": "dateNormalize",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "height_inches",
      "fieldPath": "patient.heightInches",
      "transform": "toNumber",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "dvt-assessment",
        "fieldPath": "bmi"
      }
    },
    {
      "questionKey": "weight_pounds",
      "fieldPath": "patient.weightPounds",
      "transform": "toNumber",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "dvt-assessment",
        "fieldPath": "bmi"
      }
    },
    {
      "questionKey": "ever_smoked",
      "fieldPath": "clinical.basicHistory.smoking.answer",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "drinks_alcohol",
      "fieldPath": "clinical.basicHistory.alcohol.answer",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "alcohol_drinks_per_week",
      "fieldPath": "clinical.basicHistory.alcohol.detail",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "recreational_or_street_drugs",
      "fieldPath": "clinical.basicHistory.streetDrugs.answer",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "mobility_problem_detail",
      "fieldPath": "clinical.basicHistory.mobilityProblems.detail",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "mobility_problems",
      "fieldPath": "clinical.basicHistory.mobilityProblems.answer",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "fall-risk",
        "fieldPath": "factors"
      }
    },
    {
      "questionKey": "recreational_or_street_drugs_last_use",
      "fieldPath": "clinical.basicHistory.streetDrugs.detail",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "preferred_pharmacy",
      "fieldPath": "contacts.preferredPharmacy.name",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "metal_implants",
      "fieldPath": "clinical.basicHistory.metalImplants.answer",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "metal_implants_detail",
      "fieldPath": "clinical.questionnaireAnswers.metal_implants_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "pacemaker",
      "fieldPath": "clinical.basicHistory.pacemaker.answer",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "pacemaker_manufacturer",
      "fieldPath": "clinical.structuredDetails.pacemaker.manufacturer",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cardiac_stent",
      "fieldPath": "clinical.basicHistory.cardiacStent.answer",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cardiac_stent_date",
      "fieldPath": "clinical.structuredDetails.cardiacStent.yearPlaced",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cardiac_stent_drug_eluting",
      "fieldPath": "clinical.questionnaireAnswers.cardiac_stent_drug_eluting",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "takes_current_medications",
      "fieldPath": "clinical.questionnaireAnswers.takes_current_medications",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "medication-reconciliation",
        "fieldPath": "rows"
      }
    },
    {
      "questionKey": "current_medications_detail",
      "fieldPath": "clinical.questionnaireAnswers.current_medications_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "medication-reconciliation",
        "fieldPath": "rows"
      }
    },
    {
      "questionKey": "recent_blood_thinners_detail",
      "fieldPath": "clinical.questionnaireAnswers.recent_blood_thinners_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "medication-reconciliation",
        "fieldPath": "rows"
      }
    },
    {
      "questionKey": "environmental_allergy_detail",
      "fieldPath": "clinical.questionnaireAnswers.environmental_allergy_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "clinical-significance",
        "fieldPath": "allergies"
      }
    },
    {
      "questionKey": "medication_allergies",
      "fieldPath": "clinical.questionnaireAnswers.medication_allergies",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "clinical-significance",
        "fieldPath": "allergies"
      }
    },
    {
      "questionKey": "latex_products_allergy",
      "fieldPath": "clinical.questionnaireAnswers.latex_products_allergy",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "clinical-significance",
        "fieldPath": "allergies"
      }
    },
    {
      "questionKey": "iv_contrast_xray_dye_allergy",
      "fieldPath": "clinical.questionnaireAnswers.iv_contrast_xray_dye_allergy",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "clinical-significance",
        "fieldPath": "allergies"
      }
    },
    {
      "questionKey": "food_allergy_detail",
      "fieldPath": "clinical.questionnaireAnswers.food_allergy_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "clinical-significance",
        "fieldPath": "allergies"
      }
    },
    {
      "questionKey": "medication_allergy_reactions",
      "fieldPath": "clinical.questionnaireAnswers.medication_allergy_reactions",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "clinical-significance",
        "fieldPath": "allergies"
      }
    },
    {
      "questionKey": "other_allergies",
      "fieldPath": "clinical.questionnaireAnswers.other_allergies",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "clinical-significance",
        "fieldPath": "allergies"
      }
    },
    {
      "questionKey": "adhesive_tape_allergy",
      "fieldPath": "clinical.questionnaireAnswers.adhesive_tape_allergy",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "clinical-significance",
        "fieldPath": "allergies"
      }
    },
    {
      "questionKey": "other_allergy_reactions",
      "fieldPath": "clinical.questionnaireAnswers.other_allergy_reactions",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "clinical-significance",
        "fieldPath": "allergies"
      }
    },
    {
      "questionKey": "prior_surgeries_detail",
      "fieldPath": "clinical.questionnaireAnswers.prior_surgeries_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "prior_surgeries",
      "fieldPath": "clinical.questionnaireAnswers.prior_surgeries",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "abnormal_heart_rhythm_type",
      "fieldPath": "clinical.questionnaireAnswers.abnormal_heart_rhythm_type",
      "transform": "list",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "abnormal_heart_rhythm",
      "fieldPath": "clinical.questionnaireAnswers.abnormal_heart_rhythm",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "angina",
      "fieldPath": "clinical.questionnaireAnswers.angina",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "myocardial_infarction_date",
      "fieldPath": "clinical.questionnaireAnswers.myocardial_infarction_date",
      "transform": "dateNormalize",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "high_blood_pressure",
      "fieldPath": "clinical.questionnaireAnswers.high_blood_pressure",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "high_blood_pressure_controlled",
      "fieldPath": "clinical.questionnaireAnswers.high_blood_pressure_controlled",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "congestive_heart_failure",
      "fieldPath": "clinical.questionnaireAnswers.congestive_heart_failure",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "heart_valve_problems",
      "fieldPath": "clinical.questionnaireAnswers.heart_valve_problems",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "vascular_disease",
      "fieldPath": "clinical.questionnaireAnswers.vascular_disease",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "myocardial_infarction",
      "fieldPath": "clinical.questionnaireAnswers.myocardial_infarction",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "recent_cough_or_cold",
      "fieldPath": "clinical.questionnaireAnswers.recent_cough_or_cold",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "emphysema_copd",
      "fieldPath": "clinical.questionnaireAnswers.emphysema_copd",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "asthma_attack_last_date",
      "fieldPath": "clinical.questionnaireAnswers.asthma_attack_last_date",
      "transform": "dateNormalize",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "asthma_rescue_inhaler",
      "fieldPath": "clinical.questionnaireAnswers.asthma_rescue_inhaler",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "asthma",
      "fieldPath": "clinical.questionnaireAnswers.asthma",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "pulmonary_embolism_history",
      "fieldPath": "clinical.structuredDetails.pulmonaryEmbolism.hasHistory",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "sleep_apnea",
      "fieldPath": "clinical.questionnaireAnswers.sleep_apnea",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "pulmonary_other",
      "fieldPath": "clinical.questionnaireAnswers.pulmonary_other",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "home_oxygen_use",
      "fieldPath": "clinical.questionnaireAnswers.home_oxygen_use",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "tuberculosis",
      "fieldPath": "clinical.questionnaireAnswers.tuberculosis",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "bronchitis",
      "fieldPath": "clinical.questionnaireAnswers.bronchitis",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "pulmonary_other_detail",
      "fieldPath": "clinical.questionnaireAnswers.pulmonary_other_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "kidney_failure",
      "fieldPath": "clinical.questionnaireAnswers.kidney_failure",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "kidney_failure_severity",
      "fieldPath": "clinical.questionnaireAnswers.kidney_failure_severity",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "renal_other",
      "fieldPath": "clinical.questionnaireAnswers.renal_other",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "liver_failure_or_jaundice",
      "fieldPath": "clinical.questionnaireAnswers.liver_failure_or_jaundice",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "cirrhosis",
      "fieldPath": "clinical.questionnaireAnswers.cirrhosis",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "hepatitis_type",
      "fieldPath": "clinical.questionnaireAnswers.hepatitis_type",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "hepatic_other_detail",
      "fieldPath": "clinical.questionnaireAnswers.hepatic_other_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "seizures",
      "fieldPath": "clinical.questionnaireAnswers.seizures",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "seizure_last_date",
      "fieldPath": "clinical.questionnaireAnswers.seizure_last_date",
      "transform": "dateNormalize",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "seizure_type",
      "fieldPath": "clinical.questionnaireAnswers.seizure_type",
      "transform": "list",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "seizure_frequency",
      "fieldPath": "clinical.questionnaireAnswers.seizure_frequency",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "stroke_tia",
      "fieldPath": "clinical.questionnaireAnswers.stroke_tia",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "stroke_tia_date",
      "fieldPath": "clinical.questionnaireAnswers.stroke_tia_date",
      "transform": "dateNormalize",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "alzheimers",
      "fieldPath": "clinical.questionnaireAnswers.alzheimers",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "neurologic_other_detail",
      "fieldPath": "clinical.questionnaireAnswers.neurologic_other_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "acid_reflux_heartburn",
      "fieldPath": "clinical.questionnaireAnswers.acid_reflux_heartburn",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "stomach_ulcers",
      "fieldPath": "clinical.questionnaireAnswers.stomach_ulcers",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "hiatal_hernia",
      "fieldPath": "clinical.questionnaireAnswers.hiatal_hernia",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "neurologic_other",
      "fieldPath": "clinical.questionnaireAnswers.neurologic_other",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "diabetes_type",
      "fieldPath": "clinical.questionnaireAnswers.diabetes_type",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "thyroid_type",
      "fieldPath": "clinical.questionnaireAnswers.thyroid_type",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "parkinsons",
      "fieldPath": "clinical.questionnaireAnswers.parkinsons",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "thyroid_disease",
      "fieldPath": "clinical.questionnaireAnswers.thyroid_disease",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "endocrine_other_detail",
      "fieldPath": "clinical.questionnaireAnswers.endocrine_other_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cancer_history",
      "fieldPath": "clinical.questionnaireAnswers.cancer_history",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "cancer_detail",
      "fieldPath": "clinical.questionnaireAnswers.cancer_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "infectious_other_detail",
      "fieldPath": "clinical.questionnaireAnswers.infectious_other_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "hematologic_other",
      "fieldPath": "clinical.questionnaireAnswers.hematologic_other",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "mrsa_history",
      "fieldPath": "clinical.questionnaireAnswers.mrsa_history",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "infectious_other",
      "fieldPath": "clinical.questionnaireAnswers.infectious_other",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "recent_infectious_symptoms_7_days",
      "fieldPath": "clinical.questionnaireAnswers.recent_infectious_symptoms_7_days",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "mrsa_detail",
      "fieldPath": "clinical.questionnaireAnswers.mrsa_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "blood_clots_who",
      "fieldPath": "clinical.questionnaireAnswers.blood_clots_who",
      "transform": "list",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "anemia",
      "fieldPath": "clinical.questionnaireAnswers.anemia",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "dvt-assessment",
        "fieldPath": "riskFactors"
      }
    },
    {
      "questionKey": "blood_clots_history",
      "fieldPath": "clinical.questionnaireAnswers.blood_clots_history",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "dvt-assessment",
        "fieldPath": "riskFactors"
      }
    },
    {
      "questionKey": "blood_transfusion",
      "fieldPath": "clinical.questionnaireAnswers.blood_transfusion",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "dvt-assessment",
        "fieldPath": "riskFactors"
      }
    },
    {
      "questionKey": "bleeding_or_clotting_disorder",
      "fieldPath": "clinical.questionnaireAnswers.bleeding_or_clotting_disorder",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "dvt-assessment",
        "fieldPath": "riskFactors"
      }
    },
    {
      "questionKey": "hiv_or_aids",
      "fieldPath": "clinical.questionnaireAnswers.hiv_or_aids",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "dvt-assessment",
        "fieldPath": "riskFactors"
      }
    },
    {
      "questionKey": "hematologic_other_detail",
      "fieldPath": "clinical.questionnaireAnswers.hematologic_other_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "dvt-assessment",
        "fieldPath": "riskFactors"
      }
    },
    {
      "questionKey": "musculoskeletal_problems",
      "fieldPath": "clinical.questionnaireAnswers.musculoskeletal_problems",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "arthritis_type",
      "fieldPath": "clinical.questionnaireAnswers.arthritis_type",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "musculoskeletal_other_detail",
      "fieldPath": "clinical.questionnaireAnswers.musculoskeletal_other_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "skin_breakdown_open_wounds",
      "fieldPath": "clinical.structuredDetails.openWound.present",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "paralysis_musculoskeletal_location",
      "fieldPath": "clinical.questionnaireAnswers.paralysis_musculoskeletal_location",
      "transform": "list",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "depression",
      "fieldPath": "clinical.questionnaireAnswers.depression",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "panic_anxiety_attacks",
      "fieldPath": "clinical.questionnaireAnswers.panic_anxiety_attacks",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "psychiatric_other_detail",
      "fieldPath": "clinical.questionnaireAnswers.psychiatric_other_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "currently_pregnant",
      "fieldPath": "clinical.questionnaireAnswers.currently_pregnant",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "last_menstrual_period_date",
      "fieldPath": "clinical.questionnaireAnswers.last_menstrual_period_date",
      "transform": "dateNormalize",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "additional_comments_or_history",
      "fieldPath": "clinical.questionnaireAnswers.additional_comments_or_history",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "chronic_pain_score",
      "fieldPath": "clinical.questionnaireAnswers.chronic_pain_score",
      "transform": "toNumber",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "chronic_pain",
      "fieldPath": "clinical.questionnaireAnswers.chronic_pain",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "malignant_hyperthermia_history",
      "fieldPath": "clinical.questionnaireAnswers.malignant_hyperthermia_history",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "pseudocholinesterase_deficiency",
      "fieldPath": "clinical.questionnaireAnswers.pseudocholinesterase_deficiency",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "ponv_history",
      "fieldPath": "clinical.questionnaireAnswers.ponv_history",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "consent_to_continue",
      "fieldPath": "clinical.questionnaireAnswers.consent_to_continue",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "operational_only",
        "reason": "call mechanics/consent attestation"
      }
    },
    {
      "questionKey": "completing_for_self",
      "fieldPath": "clinical.questionnaireAnswers.completing_for_self",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "has_ride_home",
      "fieldPath": "clinical.questionnaireAnswers.has_ride_home",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "ride_home_name_relationship_phone",
      "fieldPath": "clinical.questionnaireAnswers.ride_home_name_relationship_phone",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "has_after_surgery_caregiver",
      "fieldPath": "clinical.questionnaireAnswers.has_after_surgery_caregiver",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "after_surgery_caregiver_details",
      "fieldPath": "clinical.questionnaireAnswers.after_surgery_caregiver_details",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "recent_blood_thinners",
      "fieldPath": "clinical.questionnaireAnswers.recent_blood_thinners",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "medication-reconciliation",
        "fieldPath": "rows"
      }
    },
    {
      "questionKey": "environmental_allergies",
      "fieldPath": "clinical.questionnaireAnswers.environmental_allergies",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "clinical-significance",
        "fieldPath": "allergies"
      }
    },
    {
      "questionKey": "food_allergies",
      "fieldPath": "clinical.questionnaireAnswers.food_allergies",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "clinical-significance",
        "fieldPath": "allergies"
      }
    },
    {
      "questionKey": "malignant_hyperthermia_who",
      "fieldPath": "clinical.questionnaireAnswers.malignant_hyperthermia_who",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "motion_sickness",
      "fieldPath": "clinical.questionnaireAnswers.motion_sickness",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "other_anesthesia_problem",
      "fieldPath": "clinical.questionnaireAnswers.other_anesthesia_problem",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "other_anesthesia_problem_detail",
      "fieldPath": "clinical.questionnaireAnswers.other_anesthesia_problem_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "smoking_start_quit_year",
      "fieldPath": "clinical.basicHistory.smoking.detail",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "smoking_packs_per_day",
      "fieldPath": "clinical.basicHistory.smoking.detail",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "recreational_or_street_drugs_detail",
      "fieldPath": "clinical.questionnaireAnswers.recreational_or_street_drugs_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "body_piercing_other_than_earrings",
      "fieldPath": "clinical.basicHistory.bodyPiercings.answer",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "internal_nerve_stimulator",
      "fieldPath": "clinical.basicHistory.nerveStimulator.answer",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "angina_detail",
      "fieldPath": "clinical.questionnaireAnswers.angina_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "high_cholesterol_or_lipids",
      "fieldPath": "clinical.questionnaireAnswers.high_cholesterol_or_lipids",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "bypass_surgery",
      "fieldPath": "clinical.questionnaireAnswers.bypass_surgery",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "bypass_surgery_date",
      "fieldPath": "clinical.questionnaireAnswers.bypass_surgery_date",
      "transform": "dateNormalize",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cardiovascular_other",
      "fieldPath": "clinical.questionnaireAnswers.cardiovascular_other",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cardiovascular_other_detail",
      "fieldPath": "clinical.questionnaireAnswers.cardiovascular_other_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "pneumonia_last_six_weeks",
      "fieldPath": "clinical.questionnaireAnswers.pneumonia_last_six_weeks",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cpap_bipap_use",
      "fieldPath": "clinical.questionnaireAnswers.cpap_bipap_use",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "shortness_of_breath",
      "fieldPath": "clinical.questionnaireAnswers.shortness_of_breath",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "kidney_stones",
      "fieldPath": "clinical.questionnaireAnswers.kidney_stones",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "prostate_trouble",
      "fieldPath": "clinical.questionnaireAnswers.prostate_trouble",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "urinary_incontinence",
      "fieldPath": "clinical.questionnaireAnswers.urinary_incontinence",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "dialysis",
      "fieldPath": "clinical.questionnaireAnswers.dialysis",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "dialysis_detail",
      "fieldPath": "clinical.questionnaireAnswers.dialysis_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "hepatitis",
      "fieldPath": "clinical.questionnaireAnswers.hepatitis",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "hepatic_other",
      "fieldPath": "clinical.questionnaireAnswers.hepatic_other",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "neuropathy",
      "fieldPath": "clinical.questionnaireAnswers.neuropathy",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "frequent_migraines",
      "fieldPath": "clinical.questionnaireAnswers.frequent_migraines",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "paralysis_neuro",
      "fieldPath": "clinical.questionnaireAnswers.paralysis_neuro",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "gastrointestinal_other",
      "fieldPath": "clinical.questionnaireAnswers.gastrointestinal_other",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "gastrointestinal_other_detail",
      "fieldPath": "clinical.questionnaireAnswers.gastrointestinal_other_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "diabetes",
      "fieldPath": "clinical.questionnaireAnswers.diabetes",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "endocrine_other",
      "fieldPath": "clinical.questionnaireAnswers.endocrine_other",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "bleeding_or_clotting_disorder_name",
      "fieldPath": "clinical.questionnaireAnswers.bleeding_or_clotting_disorder_name",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "arthritis",
      "fieldPath": "clinical.questionnaireAnswers.arthritis",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "chronic_low_back_pain",
      "fieldPath": "clinical.questionnaireAnswers.chronic_low_back_pain",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "neck_or_jaw_problems",
      "fieldPath": "clinical.questionnaireAnswers.neck_or_jaw_problems",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "muscular_dystrophy",
      "fieldPath": "clinical.questionnaireAnswers.muscular_dystrophy",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "paralysis_musculoskeletal",
      "fieldPath": "clinical.questionnaireAnswers.paralysis_musculoskeletal",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "musculoskeletal_other",
      "fieldPath": "clinical.questionnaireAnswers.musculoskeletal_other",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "bipolar_disorder",
      "fieldPath": "clinical.questionnaireAnswers.bipolar_disorder",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "schizophrenia",
      "fieldPath": "clinical.questionnaireAnswers.schizophrenia",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "autism",
      "fieldPath": "clinical.questionnaireAnswers.autism",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "ptsd",
      "fieldPath": "clinical.questionnaireAnswers.ptsd",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "psychiatric_other",
      "fieldPath": "clinical.questionnaireAnswers.psychiatric_other",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "hysterectomy",
      "fieldPath": "clinical.questionnaireAnswers.hysterectomy",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "bilateral_tubal_ligation",
      "fieldPath": "clinical.questionnaireAnswers.bilateral_tubal_ligation",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "menopause",
      "fieldPath": "clinical.questionnaireAnswers.menopause",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "child_growth_normal",
      "fieldPath": "clinical.questionnaireAnswers.child_growth_normal",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "child_abnormalities_detail",
      "fieldPath": "clinical.questionnaireAnswers.child_abnormalities_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "patient_attestation",
      "fieldPath": "clinical.questionnaireAnswers.patient_attestation",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "operational_only",
        "reason": "call mechanics/consent attestation"
      }
    },
    {
      "questionKey": "illness_fever",
      "fieldPath": "clinical.structuredDetails.currentIllness.feverPresent",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "illness_onset_date",
      "fieldPath": "clinical.structuredDetails.currentIllness.onsetDate",
      "transform": "dateNormalize",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "illness_treatment",
      "fieldPath": "clinical.structuredDetails.currentIllness.treatment",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "illness_improving",
      "fieldPath": "clinical.structuredDetails.currentIllness.improving",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "illness_surgeon_notified",
      "fieldPath": "clinical.structuredDetails.currentIllness.surgeonNotified",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "pe_event_date",
      "fieldPath": "clinical.structuredDetails.pulmonaryEmbolism.eventDate",
      "transform": "dateNormalize",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "pe_treatment",
      "fieldPath": "clinical.structuredDetails.pulmonaryEmbolism.treatment",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "pe_recurrence",
      "fieldPath": "clinical.structuredDetails.pulmonaryEmbolism.recurrence",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "pe_on_anticoagulation",
      "fieldPath": "clinical.structuredDetails.pulmonaryEmbolism.onAnticoagulation",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "home_o2_params",
      "fieldPath": "clinical.structuredDetails.homeOxygen.flowParameters",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "home_o2_usage",
      "fieldPath": "clinical.structuredDetails.homeOxygen.usagePattern",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "home_o2_portable",
      "fieldPath": "clinical.structuredDetails.homeOxygen.portableAvailable",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cancer_diagnosis_date",
      "fieldPath": "clinical.structuredDetails.cancer.diagnosisDate",
      "transform": "dateNormalize",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cancer_last_treatment_date",
      "fieldPath": "clinical.structuredDetails.cancer.lastTreatmentDate",
      "transform": "dateNormalize",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cancer_treatment_type",
      "fieldPath": "clinical.structuredDetails.cancer.treatmentTypes",
      "transform": "list",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cancer_current_status",
      "fieldPath": "clinical.structuredDetails.cancer.currentStatus",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cardiac_event_hospitalized",
      "fieldPath": "clinical.structuredDetails.cardiacEvent.hospitalized",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cardiac_event_treatment",
      "fieldPath": "clinical.structuredDetails.cardiacEvent.treatment",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cardiac_event_last_date",
      "fieldPath": "clinical.structuredDetails.cardiacEvent.lastEventDate",
      "transform": "dateNormalize",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cardiac_event_unresolved",
      "fieldPath": "clinical.structuredDetails.cardiacEvent.unresolved",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "wound_near_surgical_site",
      "fieldPath": "clinical.structuredDetails.openWound.nearSurgicalSite",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "wound_type",
      "fieldPath": "clinical.structuredDetails.openWound.woundType",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "wound_infection_signs",
      "fieldPath": "clinical.structuredDetails.openWound.infectionSigns",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "wound_treatment",
      "fieldPath": "clinical.structuredDetails.openWound.treatment",
      "transform": "text",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "conditions_without_medication",
      "fieldPath": "clinical.questionnaireAnswers.conditions_without_medication",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "conditions_without_medication_detail",
      "fieldPath": "clinical.questionnaireAnswers.conditions_without_medication_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "patient_questions_for_team",
      "fieldPath": "clinical.questionnaireAnswers.patient_questions_for_team",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "operational_only",
        "reason": "review-screen note to care team"
      }
    },
    {
      "questionKey": "aicd",
      "fieldPath": "clinical.basicHistory.aicd.answer",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "activity_level",
      "fieldPath": "clinical.basicHistory.mobilityProblems.detail",
      "transform": "text",
      "chartPackDestination": {
        "kind": "form_field",
        "documentId": "fall-risk",
        "fieldPath": "factors"
      }
    },
    {
      "questionKey": "seizures_detail",
      "fieldPath": "clinical.questionnaireAnswers.seizures_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "renal_other_detail",
      "fieldPath": "clinical.questionnaireAnswers.renal_other_detail",
      "transform": "verbatim",
      "chartPackDestination": {
        "kind": "history_form"
      }
    },
    {
      "questionKey": "cardiac_system_umbrella",
      "fieldPath": "clinical.questionnaireAnswers.cardiac_system_umbrella",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "pulmonary_system_umbrella",
      "fieldPath": "clinical.questionnaireAnswers.pulmonary_system_umbrella",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "renal_system_umbrella",
      "fieldPath": "clinical.questionnaireAnswers.renal_system_umbrella",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "hepatic_system_umbrella",
      "fieldPath": "clinical.questionnaireAnswers.hepatic_system_umbrella",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "neurologic_system_umbrella",
      "fieldPath": "clinical.questionnaireAnswers.neurologic_system_umbrella",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "gastrointestinal_system_umbrella",
      "fieldPath": "clinical.questionnaireAnswers.gastrointestinal_system_umbrella",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "endocrine_system_umbrella",
      "fieldPath": "clinical.questionnaireAnswers.endocrine_system_umbrella",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "hematologic_system_umbrella",
      "fieldPath": "clinical.questionnaireAnswers.hematologic_system_umbrella",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "psychiatric_system_umbrella",
      "fieldPath": "clinical.questionnaireAnswers.psychiatric_system_umbrella",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "anesthesia_problems_umbrella",
      "fieldPath": "clinical.questionnaireAnswers.anesthesia_problems_umbrella",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    },
    {
      "questionKey": "infectious_system_umbrella",
      "fieldPath": "clinical.questionnaireAnswers.infectious_system_umbrella",
      "transform": "yesNoToBoolean",
      "chartPackDestination": {
        "kind": "aggregate",
        "target": "reviewOfSystems"
      }
    }
  ],
  "pendingLedgerIds": [
    "REG-001",
    "REG-002",
    "REG-004",
    "REG-005",
    "REG-006",
    "REG-007",
    "REG-008",
    "REG-009",
    "REG-010",
    "REG-011",
    "REG-012",
    "REG-013",
    "REG-014",
    "REG-015",
    "REG-016",
    "REG-017",
    "REG-018",
    "REG-019",
    "REG-020",
    "REG-021",
    "REG-022",
    "REG-023",
    "REG-024",
    "REG-025",
    "REG-026",
    "DISC-001",
    "PROC-003",
    "BASIC-004-A",
    "BASIC-006",
    "BASIC-009",
    "GEN-001",
    "GEN-003",
    "GEN-006",
    "GEN-007-B",
    "MED-001-A",
    "MED-001-C",
    "MED-003",
    "ALL-001-B",
    "ALL-001-C",
    "ALL-002-A",
    "ALL-003-A",
    "ALL-004",
    "ALL-005",
    "ALL-005-A",
    "ALL-005-B",
    "ALL-006",
    "ALL-006-C",
    "SURG-001-B",
    "SURG-002",
    "SURG-003",
    "SURG-004",
    "CARD-002",
    "CARD-009",
    "CARD-011",
    "PULM-003-A",
    "PULM-004",
    "PULM-007",
    "PULM-009",
    "PULM-012",
    "PULM-015",
    "REN-003",
    "HEP-005",
    "NEURO-003-B",
    "NEURO-004",
    "NEURO-006",
    "NEURO-008",
    "GI-004",
    "GI-005",
    "GI-006",
    "GI-008",
    "ENDO-004",
    "ONC-001-B",
    "ONC-001-C",
    "ONC-002",
    "ONC-003",
    "ONC-005",
    "INF-002",
    "INF-003",
    "INF-003-A",
    "INF-007",
    "INF-009",
    "INF-010",
    "OTHER-001",
    "HEM-006",
    "HEM-008",
    "MSK-003",
    "MSK-005",
    "PSY-004",
    "OB-001",
    "OB-003",
    "OB-004",
    "OB-005",
    "OB-006",
    "OB-007",
    "OB-008",
    "OB-009",
    "PAIN-001-A",
    "FINAL-001",
    "ANES-001",
    "ANES-004-A"
  ]
}`;

export const vipOneMnetV2TemplateData: unknown = JSON.parse(templateJsonText);

export const vipOneMnetV2BindingsData: unknown = JSON.parse(bindingsJsonText);
